<template>
  <div v-if="!!agency && !!agency.slug" class="tour-pricing">
    <div v-if="updateTourPricing" class="loader-tour-container">
      <v-loader />
    </div>
    <v-loader v-if="status === 'loading'" />
    <template v-else>
      <!-- Provider button moved to case header bar -->

      <the-case-pricing-billing
        class="pricing-billing-section rounded-3 p-12 bg-white ms-auto mb-24 mt-24"
        style="width: 87%;"
        v-model:gross="pricing.total.grossPrice"
        v-model:markup="pricing.total.markup"
        v-model:net="pricing.total.netPrice"
        v-model:quote="quotePrice"
        :lock="lock"
        :agency="agency.slug"
        :is-draft="isDraft"
        :is-sold="isSold"
        :invoice-amount="invoiceRemaingAmount"
        :case-id="Number(caseId)"
        :tour-id="Number(tourId)"
        :invoice-list-data="invoiceListData"
        is-total
        is-new-version
        @update-total-pricing="setTotalPricing"
        @load-tour-pricing="loadTourPricing"
        @update-quote-price="updateQuotePrice($event)"
        @updated-total-type-pricing="setTotalTypePricing($event, 'plane')"
        @invoiceList="invoiceList"
        @toggle-lock="toggleLock"
        @open-off-canvas="openCreateBillingInvoiceOffCanvas"
      />
      <div
        v-for="(type, index) in pricing.items.filter(
          (item) =>
            !item.name.startsWith('null') &&
            !item.name.startsWith('unknown') &&
            item.name !== 'stage_information' &&
            item.name !== 'general_information'
        )"
        :key="index"
        class="item-list mb-24 pricing-type-section rounded-3 p-12 bg-white"

      >
        <div
          :aria-controls="`pricing-collapse-${type.name}`"
          :data-bs-target="`#pricing-collapse-${type.name}`"
          aria-expanded="true"
          class="resource-header d-flex accordion-toggle align-items-center"
          data-bs-toggle="collapse"
        >
          <div class="d-flex align-items-center hotel-header">
            <div
              class="d-flex justify-content-between ms-8"
              v-if="type.name !== 'transport' && type.name !== 'transfer'"
            >
              <v-checkbox
                v-model="checkValueSupplier"
                :for-key="`supplier-all-${type.name}-check`"
                :input-id="`supplier-all-${type.name}-check`"
                :label="' '"
                :isDisabled="isSold"
                class="form-check-inline d-flex align-items-center m-0"
                label-class="ms-0 ps-8 ps-md-16 pe-8"
                @update:model-value="toggleSelectButton(`pricing-collapse-${type.name}`, type)"
              />
            </div>
            <div class="pricing-type-icon ms-xl-16 me-8 text-white d-flex align-items-center justify-content-center">
              <v-icon :icon="getAssociatedIcon(type.name.split('-')[0])" size="sm" />
            </div>
            <h3 class="h6 ff-secondary mb-0 fw-semibold">
              {{ findConceptByKey("supplier.type", type.name.split("-")[0]).name }}
            </h3>
          </div>
          <div class="d-flex align-items-center gap-12 me-32">
            <div class="text-sm fw-bold text-uppercase" style="white-space:nowrap">
              {{ $t("general.shared.total") }}: <span class="me-2 ms-6">{{ $t("general.shared.euroShort") }}</span>
              {{ formatPrice(getSupplierTypeTotal(type.suppliers)) }}
            </div>
          </div>
          <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
        </div>
        <div :id="`pricing-collapse-${type.name}`" class="resources-container accordion-body collapse show p-0">
          <div class="suppliers-body">
            <template v-for="(supplier, index) in type.suppliers" :key="index">
              <div class="supplier-container d-flex w-100">
                <div class="w-auto px-0 ps-4 px-lg-8">
                  <div class="d-flex flex-column align-items-center py-20">
                    <v-checkbox
                      v-model="supplier.invoiceChecked"
                      :for-key="`supplier-${type.name}-check`"
                      :input-id="`supplier-${type.name}-check`"
                      :label="' '"
                      class="form-check-inline d-flex align-items-center m-0"
                      label-class="ms-0 ps-8 ps-md-16 pe-8"
                      :isDisabled="isSold"
                      @update:model-value="
                        checkAllSupplierItems(supplier, type.name, supplier.invoiceChecked, supplier.id, 'all')
                      "
                    />
                  </div>
                </div>
                <div class="supplier-data p-8 ps-0 ps-xl-12 p-xl-12 w-100">
                  <div
                    :id="`collapse-header-${type.name}-${index}`"
                    :aria-controls="`collapse-${type.name}-${index}`"
                    :data-bs-target="`#collapse-${type.name}-${index}`"
                    aria-expanded="true"
                    class="d-flex justify-content-between align-items-center accordion-toggle flex-wrap gx-12 w-100"
                    data-bs-toggle="collapse"
                  >
                    <div class="td w-100">
                      <div class="d-flex align-items-center gap-8" @click.stop>
                        <div class="image-container supplier-initial-badge rounded-sm me-4">
                          {{ supplier?.name?.charAt(0) }}
                        </div>
                        <!-- Supplier name: clickable if site_url exists -->
                        <a
                          v-if="supplier.site_url"
                          class="fw-semibold text-sm text-decoration-underline"
                          style="cursor:pointer;"
                          @click.prevent.stop="openWebsite(supplier.site_url)"
                        >
                          {{ supplier.name }}
                        </a>
                        <span v-else class="fw-semibold text-sm">{{ supplier.name }}</span>
                        <span
                          v-if="supplier.isConnectedToHolded"
                          class="ms-4 btn btn-success btn-icon p-1"
                          style="cursor: pointer;"
                          title="Click to reset Holded connection"
                          @click.stop.prevent="resetHoldedConnection(supplier)"
                        >
                          <v-icon icon="check" size="sm" />
                        </span>
                        <!-- Booking info inline -->
                        <template v-if="supplier.booking_type === 'Other'">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-light text-dark border pricing-badge" style="cursor: default;">
                            {{ $t("general.shared.bookingBy") }}: {{ supplier.booking_type_meta }}
                          </span>
                        </template>
                        <template v-else-if="supplier.booking_type === 'Email'">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-light text-dark border pricing-badge" style="cursor: default;">
                            {{ $t("general.shared.bookingBy") }} {{ supplier.booking_type }}
                          </span>
                        </template>
                        <template v-else-if="supplier.booking_type === 'Portal'">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <v-button
                            v-if="supplier.booking_type_meta"
                            variant="link"
                            class="p-0 border-0 text-decoration-none pricing-badge"
                            @click.prevent.stop="openWebsite(supplier.booking_type_meta)"
                          >
                             <span class="badge rounded-pill bg-primary pricing-badge">{{ $t("general.shared.bookingBy") }} {{ supplier.booking_type }}</span>
                          </v-button>
                          <span v-else class="badge rounded-pill bg-light text-dark border pricing-badge" style="cursor: default;">
                            {{ $t("general.shared.bookingBy") }} {{ supplier.booking_type }}
                          </span>
                        </template>
                        <template v-else-if="supplier.booking_type === 'Promo code'">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-info text-white pricing-badge" style="cursor: default;">
                            {{ $t("general.shared.promoCode") }}: {{ supplier.booking_type_meta }}
                          </span>
                        </template>
                        <template v-else-if="supplier.booking_type === 'Website'">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <v-button
                            v-if="supplier.booking_type_meta"
                            variant="link"
                            class="p-0 border-0 text-decoration-none pricing-badge"
                            @click.prevent.stop="openWebsite(supplier.booking_type_meta)"
                          >
                             <span class="badge rounded-pill bg-primary pricing-badge">{{ $t("general.shared.bookingBy") }} {{ supplier.booking_type }}</span>
                          </v-button>
                          <span v-else class="badge rounded-pill bg-light text-dark border pricing-badge" style="cursor: default;">
                            {{ $t("general.shared.bookingBy") }} {{ supplier.booking_type }}
                          </span>
                        </template>
                        <template v-else>
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-danger pricing-badge" style="cursor: default;">
                            {{ $t("general.shared.bookingTypeNotFound") }}
                          </span>
                        </template>
                        <!-- Payment info inline -->
                        <template v-if="!!supplier.payment_method">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <template v-if="supplier.payment_method === 'bank_transfer' && supplier.account === null">
                            <span class="badge rounded-pill bg-danger pricing-badge" style="cursor: default;">{{ $t("general.shared.supplierAccountNotFound") }}</span>
                          </template>
                          <template v-else-if="supplier.payment_method !== 'payment_link'">
                            <span class="badge rounded-pill bg-secondary text-white pricing-badge" style="cursor: default;">
                              {{ supplier.payment_method.charAt(0).toUpperCase() + supplier.payment_method.split("_").join(" ").slice(1) }}
                            </span>
                          </template>
                          <template v-else>
                            <a
                              v-if="isPaymentLinkAvailable(supplier)"
                              :href="getPaymentLink(supplier)"
                              class="btn-link d-inline-flex align-items-center pricing-badge"
                              rel="noopener noreferrer"
                              target="_blank"
                              style="text-decoration: none;"
                              @click.prevent.stop="openWebsite(getPaymentLink(supplier))"
                            >
                              <span class="badge rounded-pill bg-primary pricing-badge">
                                {{ supplier.payment_method.charAt(0).toUpperCase() + supplier.payment_method.split("_").join(" ").slice(1) }} {{ supplier.payment_date }}
                              </span>
                            </a>
                            <span
                              v-else
                              class="badge rounded-pill bg-light text-dark border pricing-badge"
                              style="cursor: default;"
                            >
                              {{ supplier.payment_method.charAt(0).toUpperCase() + supplier.payment_method.split("_").join(" ").slice(1) }} {{ supplier.payment_date }}
                            </span>
                          </template>
                        </template>
                        <template v-else>
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-danger pricing-badge" style="cursor: default;">{{ $t("general.shared.noPaymentMethod") }}</span>
                        </template>
                        <!-- Email warnings inline -->
                        <template v-if="!supplier.email">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-danger pricing-badge" style="cursor: default;">{{ $t("tourBooking.supplierNoEmail") }}</span>
                        </template>
                        <template v-if="supplier.type_email === 'never'">
                          <span class="text-muted mx-1 pricing-badge">·</span>
                          <span class="badge rounded-pill bg-warning text-dark pricing-badge" style="cursor: default;">{{ $t("general.shared.notNotificationsSentMail") }}</span>
                        </template>
                      </div><!-- /.d-flex.gap-8 -->
                      <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
                    </div><!-- /.td.w-100 -->
                  </div><!-- /.accordion-toggle -->
                  <div class="d-flex send-notification align-self-start justify-content-end gap-8 mt-8 me-16">
                    <span
                      class="notes-icon-wrapper"
                      :class="{ 'notes-icon-wrapper--active': hasCustomNotes(supplier) }"
                    >
                    <v-button
                      class="btn-icon w-fit align-self-center"
                      size="sm"
                      variant="primary"
                      :disabled="isSold"
                      @click="openCustomNotesModal(supplier)"
                    >
                      <v-icon icon="comment" size="xs" />
                    </v-button>
                    </span>
                    <v-button
                      class="btn-icon w-fit align-self-center"
                      size="sm"
                      variant="primary"
                      :disabled="isSold"

                      @click="sendIndividualEmail(supplier, type.name)"
                    >
                      <v-icon icon="sent" size="sm" />
                    </v-button>
                  </div>
                  <div :id="`collapse-${type.name}-${index}`" class="accordion-body collapse show p-0">
                    <div class="d-none d-lg-block">
                      <div class="resources-profit-header mt-8 bg-gray-200">
                        <div class="d-flex w-100 pe-28 text-sm">
                          <div class="w-05 th p-0 p-xxl-8">
                            <span :aria-label="$t('tourBooking.selectResource')" />
                          </div>
                          <div class="th w-30">
                            {{ $t("general.shared.name") }}
                          </div>

                          <!-- <div v-if="type.name === 'hotel'" class="w-10 th ps-0 ps-xxl-8">
                              {{ $t("tourPricing.nights") }}
                            </div>
                            <div class="w-10 th">{{ $t("tourPricing.dayNumberShort") }}</div> -->
                          <div class="w-05 th">{{ $t("tourPricing.quantityShort") }}</div>
                          <div class="w-20 th">{{ $t("tourPricing.dates") }}</div>
                          <div class="w-10 fit th">{{ $t("tourPricing.netPrice") }}</div>
                          <div class="w-10 fit th">Booking</div>
                          <div class="w-10 fit th">Payment</div>
                          <div class="w-10 fit th">Invoice</div>
                        </div>
                      </div>

                      <div class="suppliers-body">
                        <div
                          v-for="(itemResource, itemResourceIndex) in supplier.itemResourcesGrouped"
                          :key="itemResourceIndex"
                          :class="{ 'bg-gray-200': itemResourceIndex % 2 !== 0 }"
                          class="wrapper"
                        >
                          <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="row align-items-center gx-12 text-sm w-100 pe-24">
                              <div
                                class="w-05 td d-flex align-items-center px-0 px-xxl-8"
                              >
                                <v-tri-state-checkbox
                                  v-model="itemResource.invoiceChecked"
                                  :for-key="`resource-group-${itemResource.supplierResourceId}-check`"
                                  :input-id="`resource-group-${itemResource.supplierResourceId}-check`"
                                  :label="' '"
                                  class="form-check-inline d-flex align-items-center m-0"
                                  label-class="ms-0"
                                  :isDisabled="isSold"
                                  @update:model-value="checkSupplierResourceGroup(supplier, itemResource)"
                                />
                              </div>
                              <div
                                v-if="itemResource.resources.length > 1"
                                class="td w-30"
                                @mouseover="toggleActionMenu(`${supplier.id}_${itemResource.supplierResourceId}_${itemResourceIndex}`)"
                              >
                                <div class="d-flex align-items-center position-relative">
                                  <div
                                    :aria-controls="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                                    :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                                    aria-expanded="false"
                                    class="accordion-toggle collapsed cursor-pointer fw-semi py-4"
                                    data-bs-toggle="collapse"
                                    v-if="
                                      itemResource.resources.length > 1 &&
                                      !isAccommodationType(type.name) &&
                                      !checkAllSupplierWithSameID(itemResource.resources)
                                    "
                                  >
                                    {{ $t("general.shared.various") }} {{ type.name }}
                                  </div>
                                  <div
                                    v-else
                                    :aria-controls="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                                    :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                                    aria-expanded="false"
                                    class="accordion-toggle collapsed cursor-pointer fw-semi py-4"
                                    data-bs-toggle="collapse"
                                  >
                                    {{ itemResource.name }}
                                  </div>
                                  <div class="icon-container" :class="{ 'show-actions': (`${supplier.id}_${itemResource.supplierResourceId}_${itemResourceIndex}` === hoveredId) }" @click.stop>
                                    <div class="d-flex py-4" @click.stop>
                                      <div class="dropup position-relative">
                                        <div class="border rounded ms-4 p-4 d-flex align-items-center gap-4">
                                          <v-button
                                            class="btn-icon p-4 ms-8 rounded-circle"
                                            size="sm"
                                            variant="gradient"
                                            :disabled="isSold"
                                            @click.stop="showPax = !showPax"
                                          >
                                            <v-icon icon="user-settings" />
                                          </v-button>

                                          <span>{{ itemResource.paxes?.length ?? 0 }} pax</span>
                                        </div>

                                        <ul
                                          class="dropdown-menu pax-dropdown shadow-sm show"
                                          v-show="showPax && `${supplier.id}_${itemResource.supplierResourceId}_${itemResourceIndex}` === hoveredId"
                                          @click.stop
                                        >
                                          <li class="dropdown-header px-12 py-4 fw-semibold text-black">Pax List</li>

                                          <li><hr class="dropdown-divider my-0" /></li>

                                          <li
                                            v-if="!itemResource.paxes || itemResource.paxes.length === 0"
                                            class="dropdown-item text-muted text-sm py-6"
                                          >
                                            No pax selected
                                          </li>

                                          <li
                                            v-for="(pax, index) in itemResource.paxes"
                                            :key="index"
                                            class="dropdown-item d-flex align-items-center gap-8 py-6"
                                          >
                                            <v-icon icon="user" size="sm" class="text-secondary" />
                                            <span class="text-sm">{{ pax }}</span>
                                          </li>
                                        </ul>
                                      </div>

                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        :disabled="isSold"
                                        @click.stop="setCurrentItem(itemResource)"
                                      >
                                        <v-icon icon="pencil" />
                                      </v-button>
                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        :disabled="isSold"
                                        @click.stop="deleteItem(itemResource)"
                                      >
                                        <v-icon icon="trash" />
                                      </v-button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                v-else
                                class="td w-30 cursor-pointer"
                                @mouseover="toggleActionMenu(`${supplier.id}_${itemResource?.tourDayItemResourceIds[0]}_${itemResourceIndex}`)"
                              >
                                <div class="d-flex align-items-center position-relative">
                                  <div class="py-4">{{ itemResource.name }}</div>
                                  <div class="icon-container" :class="{ 'show-actions': (`${supplier.id}_${itemResource?.tourDayItemResourceIds[0]}_${itemResourceIndex}` === hoveredId) }" @click.stop>
                                    <div class="d-flex py-4" @click.stop>
                                      <div class="dropup position-relative">
                                        <div class="border rounded ms-4 p-4 d-flex align-items-center gap-4">
                                          <v-button
                                            class="btn-icon p-4 ms-8 rounded-circle"
                                            size="sm"
                                            variant="gradient"
                                            :disabled="isSold"
                                            @click.stop="showPax = !showPax"
                                          >
                                            <v-icon icon="user-settings" />
                                          </v-button>

                                          <span>{{ itemResource.paxes?.length ?? 0 }} pax</span>
                                        </div>

                                        <ul
                                          class="dropdown-menu pax-dropdown shadow-sm show"
                                          v-show="showPax && `${supplier.id}_${itemResource?.tourDayItemResourceIds[0]}_${itemResourceIndex}` === hoveredId"
                                          @click.stop
                                        >
                                          <li class="dropdown-header px-12 py-4 fw-semibold text-black">Pax List</li>

                                          <li><hr class="dropdown-divider my-0" /></li>

                                          <li
                                            v-if="!itemResource.paxes || itemResource.paxes.length === 0"
                                            class="dropdown-item text-muted text-sm py-6"
                                          >
                                            No pax selected
                                          </li>

                                          <li
                                            v-for="(pax, index) in itemResource.paxes"
                                            :key="index"
                                            class="dropdown-item d-flex align-items-center gap-8 py-6"
                                          >
                                            <v-icon icon="user" size="sm" class="text-secondary" />
                                            <span class="text-sm">{{ pax }}</span>
                                          </li>
                                        </ul>
                                      </div>

                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        :disabled="isSold"
                                        @click.stop="setCurrentItem(itemResource)"
                                      >
                                        <v-icon icon="pencil" />
                                      </v-button>
                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        :disabled="isSold"
                                        @click.stop="deleteItem(itemResource)"
                                      >
                                        <v-icon icon="trash" />
                                      </v-button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- <div v-if="type.name === 'hotel'" class="w-10 td ps-0 ps-xxl-8">
                                  <template v-if="itemResource.type === 'hotel'">
                                    {{ calculateNights(itemResource.date, itemResource.endDate) }}
                                  </template>

                                  <template v-else> - </template>
                                </div>

                                <div class="w-10 td">
                                  {{ itemResource.stage }}
                                </div> -->

                              <div class="w-05 td" :class="itemResource.resources.length > 1 ? 'fw-semi' : ''">
                                {{ itemResource.quantity }}
                              </div>

                              <div
                                class="w-20 td d-flex flex-column"
                                :class="itemResource.resources.length > 1 ? 'fw-semi' : ''"
                              >
                                <span
                                  v-if="
                                    itemResource.resources.length > 1 &&
                                    !isAccommodationType(type.name) &&
                                    !checkAllSupplierWithSameID(itemResource.resources)
                                  "
                                >
                                  N/A
                                </span>
                                <template v-else>
                                  <span class="text-nowrap">
                                    {{ getDayName(itemResource.date) }}
                                    {{ formatDateTime(itemResource.date, settings.formatDate) }}
                                    <template v-if="isAccommodationType(itemResource.type)">
                                      -
                                      <template v-if="!!itemResource.endDate">
                                        {{ formatDateTime(itemResource.endDate, settings.formatDate) }}
                                      </template>

                                      <template v-else>
                                        {{ $t("general.shared.noEndDate") }}
                                      </template>
                                    </template>
                                  </span>
                                </template>                              </div>

                              <!-- isGroupIndividual -->
                              <v-pricing-and-status-update
                                :id="itemResource.id"
                                v-model:amount-paid="itemResource.amountPaid"
                                v-model:amount-pending="itemResource.amountPending"
                                v-model:gross="itemResource.grossPrice"
                                v-model:mark-to-pay="itemResource.markToPay"
                                v-model:markup="itemResource.markup"
                                v-model:net="itemResource.netPrice"
                                v-model:net-validated="itemResource.netValidated"
                                v-model:payment-complete="itemResource.paymentComplete"
                                v-model:payment-partial="itemResource.paymentPartial"
                                v-model:payment-pending="itemResource.paymentPending"
                                v-model:split-payment="itemResource.splitPayment"
                                v-model:tour-day-item-resources="itemResource.resources"
                                v-model:payment-status="itemResource.paymentStatus"
                                v-model:reservation-status="itemResource.reservationStatus"
                                v-model:invoice-status="itemResource.invoiceStatus"
                                :is-updated-by-supplier="itemResource.isUpdatedBySupplier"
                                :supplier-price="itemResource.supplierPrice"
                                :db-price="itemResource.dbPrice"
                                :is-price-validated="itemResource.isPriceValidated"
                                :account="supplier.account"
                                :agency="agency.slug"
                                :case-id="Number(caseId)"
                                :payment-method="supplier.paymentMethod"
                                :tour-day-id="itemResource.tourDayId"
                                :tour-day-item-resource-ids="itemResource.tourDayItemResourceIds"
                                :tour-id="Number(tourId)"
                                is-group-individual
                                @update-total-pricing="setTotalPricing"
                                @update-group-type="setGroupTypePricing($event, type)"
                                @updated-group-individual-paid="recalculateGroupPaid(itemResource, false)"
                                @update-item-resource-reservation-status="itemResource.reservationStatus = $event"
                                @update-item-resource-payment-status="itemResource.paymentStatus = $event"
                                @update-item-resource-invoice-status="itemResource.invoiceStatus = $event"
                                @update-case-item-resource-reservation-status="itemResource.reservationStatus = $event"
                                @update-tour-price-change="updateTourPricingChnage($event)"
                                @load-tour-pricing="loadTourPricing"
                                is-new-version
                                :is-sold="isSold"
                              />
                            </div>

                            <div
                              v-if="itemResource.resources.length > 1"
                              :aria-controls="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                              :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                              aria-expanded="false"
                              class="accordion-toggle collapsed"
                              data-bs-toggle="collapse"
                            >
                              <v-icon class="accordion-icon" icon="chevron-up" />
                            </div>
                          </div>

                          <div
                            v-if="itemResource.resources.length > 1"
                            :id="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                            class="accordion-body collapse p-0"
                          >
                            <div
                              v-for="(tourDayItemResource, index) in itemResource.resources"
                              :key="index"
                              class="row align-items-center gx-12 text-sm pe-36 dashed py-16"
                            >
                              <div class="w-05 td ps-16">
                                <v-checkbox
                                  :id="`supplier-resource-${type.name}-check`"
                                  v-model="tourDayItemResource.invoiceChecked"
                                  :for-key="`supplier-resource-${type.name}-check`"
                                  :label="' '"
                                  class="form-check-inline d-flex align-items-center m-0"
                                  label-class="ms-0"
                                  :isDisabled="isSold"
                                  @update:model-value="checkSupplierResource(itemResource, supplier)"
                                />
                              </div>

                              <div class="td w-30">
                                <div class="py-4 fw-medium d-flex align-items-center gap-4">
                                  {{
                                    !!tourDayItemResource.name
                                      ? tourDayItemResource.name
                                      : tourDayItemResource.supplierResource.name
                                  }}
                                  <span
                                    v-if="tourDayItemResource.supplierResource?.resource_type"
                                    class="badge bg-light text-dark fs-12 px-8 py-2"
                                  >
                                    {{ formatRoomType(tourDayItemResource.supplierResource.resource_type) }}
                                  </span>
                                </div>
                              </div>

                              <!-- <div v-if="type.name === 'hotel'" class="w-10 td">
                                  {{ calculateNights(tourDayItemResource.date, tourDayItemResource.endDate) }}
                                </div>

                                <div class="w-10 td">
                                  {{ itemResource.stage }}
                                </div> -->

                              <div class="w-05 td">1</div>
                              <div class="w-20 td d-flex flex-column">
                               <span class="text-nowrap">
                                 {{ getDayName(tourDayItemResource.date) }}
                                 {{ formatDateTime(tourDayItemResource.date, settings.formatDate) }}
                                 <template v-if="isAccommodationType(tourDayItemResource.supplierResource.type)">
                                   -
                                   <template v-if="!!tourDayItemResource.endDate">
                                     {{ formatDateTime(tourDayItemResource.endDate, settings.formatDate) }}
                                   </template>

                                   <template v-else>
                                     {{ $t("general.shared.noEndDate") }}
                                   </template>
                                 </template>
                               </span>
                              </div>
                              <!-- isIndividual -->
                              <v-pricing-and-status-update
                                :id="tourDayItemResource.id"
                                v-model:amount-paid="tourDayItemResource.amountPaid"
                                v-model:amount-pending="tourDayItemResource.amountPending"
                                v-model:gross="tourDayItemResource.grossPrice"
                                v-model:mark-to-pay="tourDayItemResource.markToPay"
                                v-model:markup="tourDayItemResource.markup"
                                v-model:net="tourDayItemResource.netPrice"
                                v-model:net-validated="tourDayItemResource.netValidated"
                                v-model:payment-status="tourDayItemResource.paymentStatus"
                                v-model:reservation-status="tourDayItemResource.reservationStatus"
                                v-model:invoice-status="tourDayItemResource.invoiceStatus"
                                v-model:split-payment="tourDayItemResource.splitPayment"
                                v-model:tour-day-item-resources="itemResource.resources"
                                :is-updated-by-supplier="tourDayItemResource.isUpdatedBySupplier"
                                :is-price-validated="tourDayItemResource.isPriceValidated"
                                :supplier-price="itemResource.supplierPrice"
                                :db-price="itemResource.dbPrice"
                                :account="supplier.account"
                                :agency="agency.slug"
                                :case-id="Number(caseId)"
                                :payment-method="supplier.paymentMethod"
                                :tour-day-id="tourDayItemResource.tourDayId"
                                :tour-day-item="itemResource"
                                :tour-day-item-id="tourDayItemResource.tourDayItemId"
                                :tour-day-item-resource="tourDayItemResource"
                                :tour-day-item-resource-id="tourDayItemResource.id"
                                :tour-day-item-resource-ids="[tourDayItemResource.id]"
                                :tour-id="Number(tourId)"
                                is-individual
                                @update-total-pricing="setTotalPricing"
                                @updated-individual="recalculateGroupIndividualPricing(itemResource)"
                                @update-group-type="setGroupTypePricing($event, type)"
                                @updated-individual-net-validated="recalculateGroupBulk(itemResource, 'netValidated')"
                                @updated-individual-mark-to-pay="recalculateGroupBulk(itemResource, 'markToPay')"
                                @updated-individual-paid="recalculateGroupPaid(itemResource, true)"
                                @updated-individual-split-payment="recalculateGroupPaid(itemResource, false)"
                                @update-item-resource-reservation-status="
                                  tourDayItemResource.reservationStatus = $event
                                "
                                @update-item-resource-payment-status="tourDayItemResource.paymentStatus = $event"
                                @update-item-resource-invoice-status="tourDayItemResource.invoiceStatus = $event"
                                @update-case-item-resource-reservation-status="
                                  tourDayItemResource.reservationStatus = $event
                                "
                                @update-tour-price-change="updateTourPricingChnage($event)"
                                @load-tour-pricing="loadTourPricing"
                                is-new-version
                                :is-sold="isSold"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="td d-flex justify-content-between align-items-baseline pt-8 pb-8 pe-36">
                          <div class="sub-container w-50">
                            <div class="d-flex flex-column">
                              <div class="p-4 rounded">
                                <v-button
                                  class="btn-icon p-4 rounded-circle"
                                  size="sm"
                                  variant="gradient"
                                  :disabled="isSold"
                                  @click="openResourcePricingModal(supplier.itemResourcesGrouped)"
                                >
                                  <v-icon icon="plus" />
                                </v-button>
                              </div>
                            </div>
                          </div>
                          <div class="sub-container w-40">
                            <v-supplier-product-price-update
                              :agency="agency.slug"
                              :case-id="Number(caseId)"
                              :tour-id="Number(tourId)"
                              v-model:common-net-price="supplier.totalNetPrice"
                              v-model:net-validated="supplier.netValidated"
                              v-model:mark-to-pay="supplier.isSplitted"
                              v-model:is-splitted="supplier.isSplitted"
                              v-model:amount-paid="supplier.amountPaid"
                              v-model:amount-pending="supplier.amountPending"
                              :tour-day-item-id="supplier.tourDayItemIds"
                              :resource-id="supplier.itemResourcesGrouped.map((i) => i.tourDayItemResourceIds).flat()"
                              :supplier-id="supplier.id"
                              :supplier-price="supplier.supplierPrice"
                              :db-price="supplier.dbPrice"
                              :is-price-validated="supplier.isPriceValidated"
                              :is-updated-by-supplier="supplier.isUpdatedBySupplier"
                              @update-tour-price-change="updateTourPricingChnage($event)"
                              @load-tour-pricing="(flag: boolean, data: any) => loadTourPricing(flag, data)"
                              is-new-version
                              :is-sold="isSold"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column d-lg-none suppliers-body p-0">
                      <div class="suppliers-body">
                        <div
                          v-for="(itemResource, itemResourceIndex) in supplier.itemResourcesGrouped"
                          :key="itemResourceIndex"
                          :class="{ 'bg-gray-200': itemResourceIndex % 2 !== 0 }"
                          class="wrapper ps-8"
                        >
                          <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="d-flex align-items-center gx-12 text-sm w-100 pe-32">
                              <v-tri-state-checkbox
                                v-model="itemResource.invoiceChecked"
                                :for-key="`resource-group-${itemResource.supplierResourceId}-check`"
                                :input-id="`resource-group-${itemResource.supplierResourceId}-check`"
                                :label="' '"
                                class="form-check-inline d-flex align-items-center m-0"
                                label-class="ms-0"
                                :isDisabled="isSold"
                                @update:model-value="checkSupplierResourceGroup(supplier, itemResource)"
                              />

                              <div class="w-100 ps-4">
                                <div
                                  class="position-relative"
                                  @mouseover="toggleActionMenu(`${supplier.id}_${itemResource.supplierResourceId}_${itemResourceIndex}_mobile`)"
                                >
                                  <div class="icon-container" :class="{ 'show-actions': (`${supplier.id}_${itemResource.supplierResourceId}_${itemResourceIndex}_mobile` === hoveredId) }" @click.stop>
                                    <div class="d-flex" @click.stop>
                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        :disabled="isSold"
                                        @click.stop="setCurrentItem(itemResource)"
                                      >
                                        <v-icon icon="pencil" />
                                      </v-button>
                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        :disabled="isSold"
                                        @click.stop="deleteItem(itemResource)"
                                      >
                                        <v-icon icon="trash" />
                                      </v-button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  :aria-controls="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                                  :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                                  aria-expanded="false"
                                  class="accordion-toggle collapsed fw-semi py-4"
                                  data-bs-toggle="collapse"
                                >
                                  <span>{{ $t("general.shared.name") }}: </span>
                                  <span>{{ itemResource.name }}</span>
                                </div>

                                <div
                                  v-if="isAccommodationType(type.name)"
                                  class="fw-semi py-4"
                                >
                                  <span>{{ $t("tourPricing.nights") }}: </span>

                                  <template v-if="isAccommodationType(itemResource.type)">
                                    {{ calculateNights(itemResource.date, itemResource.endDate) }}
                                  </template>

                                  <template v-else> - </template>
                                </div>

                                <div class="fw-semi py-4">
                                  <span>{{ $t("tourPricing.dayNumber") }}: </span>
                                  <span>{{ itemResource.stage }}</span>
                                </div>

                                <div class="fw-semi py-4">
                                  <span>{{ $t("tourPricing.quantity") }}: </span>
                                  <span>{{ itemResource.quantity }}</span>
                                </div>

                                <div class="fw-semi py-4">
                                  <span>{{ $t("tourPricing.dates") }}: </span>

                                  <span class="text-nowrap">
                                    {{ getDayName(itemResource.date) }}
                                    {{ formatDateTime(itemResource.date, settings.formatDate) }}
                                    <template v-if="isAccommodationType(itemResource.type)">
                                      -
                                      <template v-if="!!itemResource.endDate">
                                        {{ formatDateTime(itemResource.endDate, settings.formatDate) }}
                                      </template>

                                      <template v-else>
                                        {{ $t("general.shared.noEndDate") }}
                                      </template>
                                    </template>
                                  </span>
                                </div>
                                <!-- isGroupIndividual -->
                                <v-pricing-and-status-update
                                  :id="itemResource.supplierResourceId ?? itemResource.caseDayItemId ?? 0"
                                  v-model:amount-paid="itemResource.amountPaid"
                                  v-model:amount-pending="itemResource.amountPending"
                                  v-model:gross="itemResource.grossPrice"
                                  v-model:mark-to-pay="itemResource.markToPay"
                                  v-model:markup="itemResource.markup"
                                  v-model:net="itemResource.netPrice"
                                  v-model:net-validated="itemResource.netValidated"
                                  v-model:payment-complete="itemResource.paymentComplete"
                                  v-model:payment-partial="itemResource.paymentPartial"
                                  v-model:payment-pending="itemResource.paymentPending"
                                  v-model:split-payment="itemResource.splitPayment"
                                  v-model:payment-status="itemResource.paymentStatus"
                                  v-model:reservation-status="itemResource.reservationStatus"
                                  v-model:invoice-status="itemResource.invoiceStatus"
                                  v-model:tour-day-item-resources="itemResource.resources"
                                  :is-updated-by-supplier="itemResource.isUpdatedBySupplier"
                                  :is-price-validated="itemResource.isPriceValidated"
                                :supplier-price="itemResource.supplierPrice"
                                :db-price="itemResource.dbPrice"
                                  :account="supplier.account"
                                  :agency="agency.slug"
                                  :case-id="Number(caseId)"
                                  :payment-method="supplier.paymentMethod"
                                  :tour-day-id="itemResource.tourDayId"
                                  :tour-day-item-resource-ids="itemResource.tourDayItemResourceIds"
                                  :tour-id="Number(tourId)"
                                  class="w-100 is-mobile"
                                  is-group-individual
                                  @update-total-pricing="setTotalPricing"
                                  @update-group-type="setGroupTypePricing($event, type)"
                                  @updated-group-individual-paid="recalculateGroupPaid(itemResource, false)"
                                  @update-item-resource-reservation-status="itemResource.reservationStatus = $event"
                                  @update-item-resource-payment-status="itemResource.paymentStatus = $event"
                                  @update-item-resource-invoice-status="itemResource.invoiceStatus = $event"
                                  @update-case-item-resource-reservation-status="
                                    itemResource.reservationStatus = $event
                                  "
                                  @update-tour-price-change="updateTourPricingChnage($event)"
                                  @load-tour-pricing="loadTourPricing"
                                  is-new-version
                                  :is-sold="isSold"
                                />
                              </div>
                            </div>

                            <div
                              v-if="itemResource.resources.length > 1"
                              :aria-controls="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                              :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                              aria-expanded="false"
                              class="accordion-toggle collapsed"
                              data-bs-toggle="collapse"
                            >
                              <v-icon class="accordion-icon" icon="chevron-up" />
                            </div>
                          </div>

                          <div
                            v-if="itemResource.resources.length > 1"
                            :id="`collapse-tour-day-item-resource-${itemResource.supplierResourceId}-${itemResourceIndex}-dropdown`"
                            class="accordion-body collapse p-0 pt-28 ps-16"
                          >
                            <div
                              v-for="(tourDayItemResource, index) in itemResource.resources"
                              :key="index"
                              class="d-flex text-sm pe-32 dashed py-16"
                            >
                              <v-checkbox
                                :id="`supplier-resource-${type.name}-check`"
                                v-model="tourDayItemResource.invoiceChecked"
                                :for-key="`supplier-resource-${type.name}-check`"
                                :label="' '"
                                class="form-check-inline d-flex align-items-center m-0"
                                label-class="ms-0"
                                :isDisabled="isSold"
                                @update:model-value="checkSupplierResource(itemResource, supplier)"
                              />

                              <div class="fw-medium">
                                <div class="py-4">
                                  <span>{{ $t("general.shared.name") }}: </span>
                                  <span>{{
                                      !!tourDayItemResource.name
                                        ? tourDayItemResource.name
                                        : tourDayItemResource.supplierResource.name
                                    }}</span>
                                  <span
                                    v-if="tourDayItemResource.supplierResource?.resource_type"
                                    class="badge bg-light text-dark fs-12 px-8 py-2 ms-4"
                                  >
                                    {{ formatRoomType(tourDayItemResource.supplierResource.resource_type) }}
                                  </span>
                                </div>

                                <div v-if="isAccommodationType(type.name)" class="py-4">
                                  <span>{{ $t("tourPricing.nights") }}: </span>
                                  <span>
                                    {{ calculateNights(tourDayItemResource.date, tourDayItemResource.endDate) }}
                                  </span>
                                </div>

                                <div class="py-4">
                                  <span>{{ $t("tourPricing.dayNumber") }}: </span>
                                  {{ itemResource.stage }}
                                </div>

                                <div class="py-4">
                                  <span>{{ $t("tourPricing.quantity") }}: 1</span>
                                </div>

                                <div class="py-4">
                                  <span>{{ $t("tourPricing.dates") }}: </span>

                                  <span class="text-nowrap">
                                    {{ getDayName(tourDayItemResource.date) }}
                                    {{ formatDateTime(tourDayItemResource.date, settings.formatDate) }}
                                    <template v-if="isAccommodationType(tourDayItemResource.supplierResource.type)">
                                      -
                                      <template v-if="!!tourDayItemResource.endDate">
                                        {{ formatDateTime(tourDayItemResource.endDate, settings.formatDate) }}
                                      </template>

                                      <template v-else>
                                        {{ $t("general.shared.noEndDate") }}
                                      </template>
                                    </template>
                                  </span>
                                </div>
                                <!-- isIndividual -->
                                <v-pricing-and-status-update
                                  :id="tourDayItemResource.id"
                                  v-model:amount-paid="tourDayItemResource.amountPaid"
                                  v-model:amount-pending="tourDayItemResource.amountPending"
                                  v-model:gross="tourDayItemResource.grossPrice"
                                  v-model:mark-to-pay="tourDayItemResource.markToPay"
                                  v-model:markup="tourDayItemResource.markup"
                                  v-model:net="tourDayItemResource.netPrice"
                                  v-model:net-validated="tourDayItemResource.netValidated"
                                  v-model:payment-status="tourDayItemResource.paymentStatus"
                                  v-model:reservation-status="tourDayItemResource.reservationStatus"
                                  v-model:invoice-status="tourDayItemResource.invoiceStatus"
                                  v-model:split-payment="tourDayItemResource.splitPayment"
                                  v-model:tour-day-item-resources="itemResource.resources"
                                  :is-updated-by-supplier="tourDayItemResource.isUpdatedBySupplier"
                                  :is-price-validated="tourDayItemResource.isPriceValidated"
                                :supplier-price="itemResource.supplierPrice"
                                :db-price="itemResource.dbPrice"
                                  :account="supplier.account"
                                  :agency="agency.slug"
                                  :case-id="Number(caseId)"
                                  :payment-method="supplier.paymentMethod"
                                  :tour-day-id="tourDayItemResource.tourDayId"
                                  :tour-day-item="itemResource"
                                  :tour-day-item-id="tourDayItemResource.tourDayItemId"
                                  :tour-day-item-resource="tourDayItemResource"
                                  :tour-day-item-resource-id="tourDayItemResource.id"
                                  :tour-day-item-resource-ids="[tourDayItemResource.id]"
                                  :tour-id="Number(tourId)"
                                  class="is-mobile w-100"
                                  is-individual
                                  @update-total-pricing="setTotalPricing"
                                  @updated-individual="recalculateGroupIndividualPricing(itemResource)"
                                  @update-group-type="setGroupTypePricing($event, type)"
                                  @updated-individual-net-validated="recalculateGroupBulk(itemResource, 'netValidated')"
                                  @updated-individual-mark-to-pay="recalculateGroupBulk(itemResource, 'markToPay')"
                                  @updated-individual-paid="recalculateGroupPaid(itemResource, true)"
                                  @updated-individual-split-payment="recalculateGroupPaid(itemResource, false)"
                                  @update-item-resource-reservation-status="
                                    tourDayItemResource.reservationStatus = $event
                                  "
                                  @update-item-resource-payment-status="tourDayItemResource.paymentStatus = $event"
                                  @update-item-resource-invoice-status="tourDayItemResource.invoiceStatus = $event"
                                  @update-case-item-resource-reservation-status="
                                    tourDayItemResource.reservationStatus = $event
                                  "
                                  @update-tour-price-change="updateTourPricingChnage($event)"
                                  @load-tour-pricing="loadTourPricing"
                                  is-new-version
                                  :is-sold="isSold"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="td d-flex flex-column align-items-lg-center flex-lg-column pt-8 pb-8 pe-36">
                          <div class="d-flex justify-content-between">
                            <span class="fw-bold">
                              {{ $t("general.shared.payAmount") }} : {{ $t("general.shared.euroShort") }}
                              {{ formatPrice(totalPayablePriceDayTour(supplier.name)) }}
                            </span>

                            <span class="fw-bold">
                              {{ $t("general.shared.pendingAmount") }} : {{ $t("general.shared.euroShort") }}
                              {{ formatPrice(totalPendingPriceDayTour(supplier.name)) }}
                            </span>

                            <span class="fw-bold">
                              {{ $t("general.shared.paidAmount") }} : {{ $t("general.shared.euroShort") }}
                              {{ formatPrice(totalAmountPaid(supplier.name)) }}
                            </span>
                          </div>
                          <v-supplier-product-price-update
                            :agency="agency.slug"
                            :case-id="Number(caseId)"
                            :tour-id="Number(tourId)"
                            v-model:common-net-price="supplier.totalNetPrice"
                            v-model:net-validated="supplier.netValidated"
                            v-model:mark-to-pay="supplier.markToPay"
                            v-model:is-splitted="supplier.isSplitted"
                            v-model:amount-paid="supplier.amountPaid"
                            v-model:amount-pending="supplier.amountPending"
                            :tour-day-item-id="supplier.tourDayItemIds"
                            :resource-id="supplier.itemResourcesGrouped[0].tourDayItemResourceIds"
                            :supplier-id="supplier.id"
                            :supplier-price="supplier.supplierPrice"
                            :db-price="supplier.dbPrice"
                            :is-price-validated="supplier.isPriceValidated"
                            :is-updated-by-supplier="supplier.isUpdatedBySupplier"
                            is-mobile
                            @update-tour-price-change="updateTourPricingChnage($event)"
                            @load-tour-pricing="(flag: boolean, data: any) => loadTourPricing(flag, data)"
                            is-new-version
                            :is-sold="isSold"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>

    <the-pricing-invoice-create-off-canvas
      v-if="offCanvasToShow === 'the-pricing-invoice-create-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :items="items"
      :pricing="pricing"
      :total-invoice="totalInvoice"
      :invoice-amount="invoiceRemaingAmount"
      :quote-price="quotePrice"
      :tour-id="Number(tourId)"
      @closed="closeOffCanvas"
      @invoiceList="invoiceList"
      version="new"
    />

    <div v-if="showLoader" class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ $t("general.button.loading") }}</span>
    </div>

    <the-hotel-pricing-summary-modal
      v-if="showmodal"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :summary-data="summaryData"
      :tour-id="Number(tourId)"
      @closed="closeModal"
      @load-tour-pricing="loadTourPricing"
    />

    <the-tour-day-item-details-off-canvas-v2
      v-if="offCanvasToShow === 'the-tour-day-item-details-off-canvas'"
      :agency="agency.slug"
      :client-tour-id="Number(caseId)"
      :tour-id="Number(tourId)"
      :status="statusTourDayItem"
      @closed="
        closeOffCanvas();
        clearCurrentTourDayItem();
        loadTourPricing();
      "
      @emit-reload-tour="loadTourPricing"
    />
    <the-tour-statuses-send-notification-off-canvas
      v-if="offCanvasToShow === 'the-tour-statuses-send-notification-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :resources="resources"
      :supplier-data-for-email="supplierDataForEmail"
      :tour-id="Number(tourId)"
      @closed="closeOffCanvas()"
      @reload-items="loadTourPricing"
      is-new-version
    />

    <the-custom-notes-off-canvas
      v-if="offCanvasToShow === 'the-custom-notes-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :tour-id="Number(tourId)"
      :supplier="supplierIdForCustomNote"
      @closed="closeOffCanvas()"
      @reload-items="loadTourPricing"
      is-new-version
    />

    <the-case-resource-update-price-off-canvas
      v-if="offCanvasToShow === 'the-case-resource-update-price-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :rooms="roomData"
      @closed="closeOffCanvas()"
      @reload-items="loadTourPricing"
    />

    <the-providers-modal
      v-if="inVoiceSummary"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :tour-id="Number(tourId)"
      :pricing="pricing"
      :paymentMethod="paymentMethod"
      @closed="closeInvoiceSummaryModal()"
      @reload-items="loadTourPricing"
    />
  </div>
</template>

<script lang="ts" setup name="TheCasePricing">
import _ from "lodash";
import { computed, getCurrentInstance, markRaw, onMounted, onUnmounted, ref } from "vue";
import { VCheckbox } from "@uniqoders/form";
import { DateTime } from "luxon";
import api from "@/api";
import { TYPE, useToast } from "vue-toastification";
import { useAuthStore } from "@/stores/auth";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import { findConceptByKey, mapConcepts } from "@/helpers/ConceptHelper";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import { useUserStore } from "@/stores/user";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import ThePricingInvoiceCreateOffCanvas from "@/components/pricing/ThePricingInvoiceCreateOffCanvas.vue";
import useOffCanvasUtils from "@/helpers/OffCanvasUtils";
import TourDayItemResource from "@/api/objects/TourDayItemResource";
import { useAppStore } from "@/stores/app";
import { usePriceStore } from "@/stores/priceCalculation";
import TheHotelPricingSummaryModal from "@/components/case/parts/TheHotelPricingSummaryModal.vue";
import useConcepts from "@/helpers/Concepts";
import VTriStateCheckbox from "@/components/vendor/basic/form/VTriStateCheckbox.vue";
import { calculateAllNetValidated, calculateAllPaymentStatus, calculatePriceGroup, formatPrice, roundPrice } from "@/composables/pricing";
import { formatRoomType } from "@/composables/roomType";
import TheTourDayItemDetailsOffCanvasV2 from "@/components/tour/V2/TheTourDayItemDetailsOffCanvasV2.vue";
import TheTourStatusesSendNotificationOffCanvas from "@/components/reservation/TheTourStatusesSendNotificationOffCanvas.vue";
import VPricingAndStatusUpdate from "@/components/pricing/VPricingAndStatusUpdate.vue";
import VSupplierProductPriceUpdate from "@/components/pricing/VSupplierProductPriceUpdate.vue";
import TheConfirmationModal from "@/components/modal/TheConfirmationModal.vue";
import TheLock from "@/assets/icons/TheLock.vue";
import TheUnLock from "@/assets/icons/TheUnLock.vue";
import TheCustomNotesOffCanvas from "@/components/notes/TheCustomNotesOffCanvas.vue";
import TheCasePricingBilling from "@/components/pricing/TheCasePricingBilling.vue";
import TheProvidersModal from "@/components/invoice/TheProvidersModal.vue";
import TheCaseResourceUpdatePriceOffCanvas from "@/components/pricing/TheCaseResourceUpdatePriceOffCanvas.vue";
import { useI18n } from "vue-i18n";

export interface IItemsTypes {
  types: any[];
  resourceIds: number[];
}

interface IPrice {
  grossPrice: number;
  markup: number;
  netPrice: number;
}

export interface IPricingItemSupplierResource {
  amountPaid: number | string;
  amountPending: number;
  date: string;
  endDate: string | DateTime;
  grossPrice: number;
  id: number;
  invoiceChecked: boolean;
  invoiceStatus: string;
  isOptional: false;
  markup: number;
  markToPay: boolean;
  modelId: number;
  modelType: string;
  name: string;
  netPrice: number;
  netValidated: boolean;
  pax: number;
  paymentStatus: string;
  reservationStatus: string;
  splitPayment: boolean;
  stage: number;
  supplierResourceId: string | number;
  tourDayId: number;
  tourDayItemId: number;
  type: string;
  supplierPrice: number;
  isUpdatedBySupplier: boolean;
  isPriceValidated: boolean;
  dbPrice: number;
}

export interface IPricingItemSupplierResourceGrouped {
  account: string;
  amountPaid: number | string;
  amountPending: number;
  date: string;
  endDate: string;
  grossPrice: number;
  id: string;
  invoiceChecked: boolean;
  markup: number;
  markToPay: boolean | "mixed";
  name: string;
  netPrice: number;
  netValidated: boolean | "mixed";
  paymentComplete: boolean | "mixed";
  paymentPartial: boolean | "mixed";
  paymentPending: boolean | "mixed";
  paymentCancelled: boolean | "mixed";
  paymentMethod: string;
  paymentDate: string;
  bookingType: string;
  bookingTypeMeta: string;
  quantity: number;
  resources: IPricingItemSupplierResource[];
  splitPayment: boolean | "mixed";
  stage: number;
  tourDayId: number;
  tourDayItemIds: number[];
  tourDayItemResourceIds: number[];
  type: string;
  typeResource: string;
  supplierPrice: number;
  isUpdatedBySupplier: boolean;
  isPriceValidated: boolean;
  paymentStatus: string;
  reservationStatus: string;
  invoiceStatus: string;
  dbPrice: number;
}

interface IPricingItemSupplier {
  account: string;
  email: string;
  id: string | number;
  invoiceChecked: boolean | "mixed";
  itemResourcesGrouped: IPricingItemSupplierResourceGrouped[];
  mapUrl: string;
  name: string;
  paymentMethod: string;
  phone: string;
  preferredLanguage: string;
  priceRange: number;
  siteUrl: string;
  type: string;
  typeEmail: string;
  amountPaid: number | string;
  amountPending: number;
  comonNetPrice: number;
  netValidated: boolean;
  markToPay: boolean;
  isSplitted: boolean;
  tourDayItemIds: number;
  booking_type: string | null;
  booking_type_meta: string | null;
}

interface IPricingItems {
  name: string;
  suppliers: IPricingItemSupplier[];
  total: IPrice;
}

interface IPricing {
  items: IPricingItems[];
  total: IPrice;
}

interface SelectAllToggleState {
  [key: string]: boolean;
}

export type HotelDataType = {
  hotelName: string;
  paidAmount?: number;
  pendingAmount?: number;
  payableAmount?: number;
};

const { caseId, tourId } = defineProps<{
  caseId: string;
  tourId: string;
  clientCaseIsDraft?: boolean;
}>();

const userStore = useUserStore();
const authStore = useAuthStore();
const appStore = useAppStore();
const priceStore = usePriceStore();
const toast = useToast();
const { t } = useI18n();
const { offCanvasToShow, closeOffCanvas, openOffCanvas } = useOffCanvasUtils();
const { concepts } = useConcepts();
const instance = getCurrentInstance();
const $modal = instance?.appContext.config.globalProperties.$modal;
const $toast = instance?.appContext.config.globalProperties.$toast;

const settings = computed(() => appStore.settings);
const agency = computed(() => authStore.agency);
const currentTour = computed(() => userStore.currentTour);
const isDraft = computed(() => userStore.caseIsDraft);
const isSold = computed(() => userStore.caseIsSold);

const itemTypes = computed(() => {
  if (!!concepts.value && concepts.value["supplier.type"]) {
    return mapConcepts(concepts.value["supplier.type"]);
  }
  return [];
});

const status = ref("loading");
const statusTotalPricing = ref("loading");
const pricing = ref<IPricing>({} as IPricing);
const resources = ref<IPricingItemSupplierResource[]>([]);
const totalInvoice = ref(0);

const summaryDataMap = computed<Map<string, HotelDataType>>(() => {
  const map = new Map<string, HotelDataType>();
  if (!pricing.value?.items) return map;

  for (const supplierType of pricing.value.items) {
    if (!supplierType?.suppliers) continue;
    for (const supplier of supplierType.suppliers) {
      if (!supplier?.itemResourcesGrouped) continue;
      const dataIds = _.flatMap(supplier.itemResourcesGrouped, (item: any) => item.tourDayItemResourceIds || []);
      const totalNetPrice = roundPrice(_.sumBy(supplier.itemResourcesGrouped, (item: any) => Number(item.netPrice || 0)));
      const totalPaid = roundPrice(_.sumBy(supplier.itemResourcesGrouped, (item: any) => Number(item.amountPaid || 0)));
      const matchingPrices = priceStore.price.filter((price) => dataIds.includes(price.id));
      const totalReadyToPrice = matchingPrices.length
        ? roundPrice(_.sumBy(matchingPrices, (price) => Number(price.readyToPrice || 0)))
        : 0;
      map.set(supplier.name, {
        hotelName: supplier.name,
        paidAmount: totalPaid,
        pendingAmount: roundPrice(totalNetPrice - totalPaid - totalReadyToPrice),
        payableAmount: totalReadyToPrice,
      });
    }
  }

  return map;
});

const summaryData = computed<HotelDataType[]>(() => [...summaryDataMap.value.values()]);
const showmodal = ref(false);
const items = ref({
  types: [],
  resourceIds: [],
});
const hoveredId = ref(0);
const statusTourDayItem = ref("loading");
const supplierDataForEmail = ref<IPricingItemSupplierResourceGrouped[]>([]);
const updateTourPricing = ref(false);
const selectAllToggle = ref<SelectAllToggleState>({} as SelectAllToggleState);
const lock = ref(false);
const quotePrice = ref(0);
const initialQuotePrice = ref(0);
const currentAction = ref<string | null>(null);
const checkValueSupplier = ref(false);
const supplierIdForCustomNote = ref(0);
const btnLoading = ref(false);
const invoiceListData = ref<any[]>([]);
const invoiceRemaingAmount = ref<any>({});
const inVoiceSummary = ref(false);
const paymentMethod = ref<any>({});
const showLoader = ref(false);
const showPax = ref(false);
const roomData = ref<any>([]);

const DEBUG_CASE_IDS = [870, 1008, 866];
const isDebugCase = computed(() => DEBUG_CASE_IDS.includes(Number(caseId)));

const getClientMemory = () => {
  const mem = (window as any).performance?.memory;
  if (!mem) return null;
  return {
    usedJSHeapSize: mem.usedJSHeapSize,
    totalJSHeapSize: mem.totalJSHeapSize,
    jsHeapSizeLimit: mem.jsHeapSizeLimit,
  };
};

const pendingClientLogs: Array<{ message: string; level: 'info' | 'warning' | 'error'; context: Record<string, any> }> = [];

const logClient = (message: string, level: 'info' | 'warning' | 'error' = 'info', context: Record<string, any> = {}) => {
  if (!isDebugCase.value) return;
  const prefix = '[PRICING_CLIENT_' + Number(caseId) + ']';
  const payload = { ...context, memory: getClientMemory() };
  console.log(prefix, message, payload);
  if (!agency.value) return;
  pendingClientLogs.push({ message, level, context: payload });
};

const flushClientLogs = async () => {
  if (pendingClientLogs.length === 0) return;
  const logs = pendingClientLogs.splice(0);
  try {
    await api.case.casePricingClientLog(agency.value.slug, Number(caseId), { logs });
  } catch {
    /* Ignore client log failures to avoid interfering with the page. */
  }
};

onMounted(async () => {
  const mountStart = performance.now();
  logClient('onMounted: start loading pricing page', 'info');
  // Fetch pricing and invoices in parallel to reduce load time
  try {
    await Promise.all([
      loadTourPricing(),
      invoiceList(),
    ]);
  } catch (error: any) {
    const isTimeout = error?.code === "ECONNABORTED" || error?.response?.status === 504;
    logClient('onMounted: failed to load pricing page', 'error', {
      elapsed_ms: Math.round(performance.now() - mountStart),
      is_timeout: isTimeout,
      status: error?.response?.status,
      message: error?.message,
    });
    toast.error(
      isTimeout
        ? t("general.shared.pricingTimeout")
        : t("general.shared.pricingLoadError")
    );
  } finally {
    status.value = "loaded";
    logClient('onMounted: pricing page loading finished', 'info', {
      elapsed_ms: Math.round(performance.now() - mountStart),
      status: status.value,
    });
    flushClientLogs();
  }
});

const formatDateTime = (date: string, format = "dd/MM/yyyy") => {
  if (!date) return "";

  // ✅ Parse as a local date (ignore timezone offset)
  return DateTime.fromISO(date, { zone: "utc" }).toFormat(format);
};

const accommodationTypes = ["hotel", "refuge"];
const isAccommodationType = (type: string | undefined) => accommodationTypes.includes(type || "");

const checkAllSupplierWithSameID = (items: any[]) => {
  if (!items || items.length === 0) return false;

  const uniqueIds = _.uniq(items.map((i) => i.supplierResourceId));
  return uniqueIds.length === 1;
};

const invoiceList = async () => {
  const start = performance.now();
  logClient('invoiceList: start fetching invoices', 'info');
  try {
    const response = await api.invoice.getInvoice(agency.value.slug, Number(caseId));
    invoiceListData.value = response?.content;
    invoiceRemaingAmount.value = response.meta;
    logClient('invoiceList: invoices fetched', 'info', {
      elapsed_ms: Math.round(performance.now() - start),
      invoice_count: response?.content?.length ?? 0,
    });
  } catch (error: any) {
    const isTimeout = error?.code === "ECONNABORTED" || error?.response?.status === 504;
    invoiceListData.value = [];
    logClient('invoiceList: failed to fetch invoices', 'error', {
      elapsed_ms: Math.round(performance.now() - start),
      is_timeout: isTimeout,
      status: error?.response?.status,
      message: error?.message,
    });
    toast.error(
      isTimeout
        ? t("general.shared.invoiceTimeout")
        : t("general.shared.invoiceLoadError")
    );
  } finally {
    flushClientLogs();
  }
};

const getDayName = (date: string): string => {
  return DateTime.fromISO(date, { zone: "utc" }).toFormat("EEE,");
};



const toggleLock = () => {
  lock.value = !lock.value;
};

const toggleSelectButton = (collapseId: any, supplierType: any) => {
  if (supplierType.name !== "transfer" && supplierType.name !== "transport") {
    const collapseElement = document.getElementById(collapseId);
    collapseElement?.classList?.remove("collapsing");
    collapseElement?.classList?.add("show");

    const currentState = selectAllToggle.value[supplierType.name] || false;
    selectAllToggle.value[supplierType.name] = !currentState;
    checkValueSupplier.value = !currentState;

    if (!selectAllToggle.value[supplierType.name]) {
      deselectAllResources(supplierType);
    } else {
      checkAllResources(supplierType);
    }
  }
};

const updateTourPricingChnage = (value: boolean) => {
  updateTourPricing.value = value;
};

const isPaymentLinkAvailable = (supplier: any): boolean => {
  return (
    supplier?.itemResourcesGrouped?.map((i: any) => i.paymentLink !== null && i.paymentLink)?.filter(Boolean)[0] !==
    undefined
  );
};

const getPaymentLink = (supplier: any): string | null => {
  return (
    supplier?.itemResourcesGrouped?.map((i: any) => i.paymentLink !== null && i.paymentLink)?.filter(Boolean)[0] || null
  );
};

const setTotalTypePricing = async (response: any[], pricingType: IPricingItems | string) => {
  if (typeof pricingType === "object" && pricingType?.name === "plane") {
    await invoiceList();
  }

  const data = pricingType === "plane" ? _.find(pricing.value?.items, { name: "plane" }) : pricingType;

  data?.suppliers?.forEach((supplier: IPricingItemSupplier) => {
    supplier.itemResourcesGrouped.forEach((itemResources: IPricingItemSupplierResourceGrouped) => {
      response.forEach((responseResource: any) => {
        const itemResource = _.find(itemResources.resources, { id: responseResource.id });

        if (itemResource) {
          itemResource.grossPrice = roundPrice(responseResource.gross_value);
          itemResource.markup = roundPrice(responseResource.markup_value);
          itemResource.netPrice = roundPrice(responseResource.net_value);

          const grossPrice = _.sumBy(itemResources.resources, (r) => Number(r.grossPrice) || 0);
          const netPrice = _.sumBy(itemResources.resources, (r) => Number(r.netPrice) || 0);

          itemResources.grossPrice = roundPrice(grossPrice);
          itemResources.netPrice = roundPrice(netPrice);
          itemResources.markup = responseResource.markup_value;
        }
      });
    });
  });
};

const setGroupTypePricing = (
  { grossPrice, markup, netPrice }: { grossPrice: number; markup: number; netPrice: number },
  type: IPricingItems
) => {
  type.total.grossPrice = roundPrice(grossPrice);
  type.total.markup = roundPrice(markup);
  type.total.netPrice = roundPrice(netPrice);
};

const setTotalPricing = ({
                           grossPrice,
                           markup,
                           netPrice,
                         }: {
  grossPrice: number;
  markup: number;
  netPrice: number;
}) => {
  statusTotalPricing.value = "loading";

  pricing.value.total.grossPrice = roundPrice(grossPrice);
  pricing.value.total.markup = roundPrice(markup);
  pricing.value.total.netPrice = roundPrice(netPrice);

  statusTotalPricing.value = "loaded";
};

const recalculateGroupBulk = (itemResource: IPricingItemSupplierResourceGrouped, variable: string) => {
  const allTrue = _.every(itemResource.resources, (item: IPricingItemSupplierResource) => item[variable] === true);

  if (allTrue) {
    itemResource[variable] = true;
  } else {
    const someTrue = _.some(itemResource.resources, (item: IPricingItemSupplierResource) => item[variable] === true);
    itemResource[variable] = someTrue ? "mixed" : false;
  }
};

const recalculateGroupPaid = (itemResource: IPricingItemSupplierResourceGrouped, updatePrices = true) => {
  if (updatePrices) {
    const { amountPaid, amountPending } = calculatePriceGroup(itemResource.resources);

    itemResource.amountPaid = amountPaid;
    itemResource.amountPending = amountPending;
  }

  const paymentPartial: boolean | "mixed" = calculateAllPaymentStatus(itemResource.resources, "partial");

  itemResource.netValidated = calculateAllNetValidated(itemResource.resources);
  itemResource.paymentComplete = calculateAllPaymentStatus(itemResource.resources, "complete");
  itemResource.paymentPending = calculateAllPaymentStatus(itemResource.resources, "pending");
  itemResource.paymentPartial = paymentPartial;
  itemResource.paymentCancelled = calculateAllPaymentStatus(itemResource.resources, "cancelled");
  itemResource.splitPayment = paymentPartial;
};

const recalculateGroupIndividualPricing = (itemResource: IPricingItemSupplierResourceGrouped) => {
  const { netPrice, grossPrice, markup } = calculatePrice(itemResource.resources);

  itemResource.netPrice = netPrice;
  itemResource.markup = markup;
  itemResource.grossPrice = grossPrice;
};

const calculateNights = (initDate: string, endDate: string): number => {
  if (!initDate || !endDate) return 0;

  const init = DateTime.fromISO(initDate).startOf("day");
  const end = DateTime.fromISO(endDate).startOf("day");

  return end.diff(init, "days").days;
};

const openWebsite = (url: string) => {
  window.open(url, "_blank");
};

const calculatePrice = (
  tourDayItemResources: TourDayItemResource[] | IPricingItemSupplierResource[]
): Record<string, any> => {
  const { netPrice, grossPrice } = calculatePriceGroup(tourDayItemResources);

  let markup: number = ((grossPrice - netPrice) * 100) / netPrice;

  markup = roundPrice(markup);

  if (Number.isNaN(markup)) {
    markup = 0;
  }

  return {
    netPrice,
    grossPrice,
    markup,
  };
};

const mapResourcesToNotification = (type: string, id: number) => {
  resources.value = [];
  supplierDataForEmail.value = [];

  const supplierType = _.find(pricing.value.items, { name: type });

  if (!supplierType) return;

  _.forEach(supplierType.suppliers, (supplier) => {
    if (supplier.id === id) {
      // Ensure the case day item type (pricing item name) is available so
      // the email summary modal can detect transfer/transport suppliers
      // even when item_data.type is a resource type (e.g. taxi_stand).
      supplierDataForEmail.value.push({ ...supplier, itemType: type });
      const checkedResourceIds = _(supplier.itemResourcesGrouped)
        .flatMap("resources")
        .filter((r: any) => r.invoiceChecked === true || r.invoiceChecked === "mixed")
        .map("id")
        .value();

      resources.value.push(...checkedResourceIds);
    }
  });
};

const checkAllSupplierItems = (supplier: any, type: string, checked: boolean, id: number, checkboxType: string) => {
  supplier.itemResourcesGrouped.forEach((item: any) => {
    item.invoiceChecked = checkboxType === "all" ? checked : item.invoiceChecked;
    item.resources.forEach((resource: any) => {
      resource.invoiceChecked = checkboxType === "all" ? checked : resource.invoiceChecked;
    });
  });

  mapResourcesToNotification(type, id);
};

const openResourcePricingModal = (rooms: any) => {
  const affectedResources = rooms?.map((item: any) => ({
    id: item.tourDayItemResourceIds, // array of IDs
    name: item.name,
    qty: item.quantity,
    price: item.netPrice,
  }));

  roomData.value = affectedResources;

  openOffCanvas("the-case-resource-update-price-off-canvas");
};

const openSendNotificationsModal = () => {
  openOffCanvas("the-tour-statuses-send-notification-off-canvas");
};

const sendIndividualEmail = (supplier: any, type: string) => {
  // Check if any items are already selected for this supplier
  const hasCheckedItems = supplier.itemResourcesGrouped?.some(
    (item: any) =>
      item.invoiceChecked === true ||
      item.invoiceChecked === "mixed" ||
      item.resources?.some((r: any) => r.invoiceChecked === true || r.invoiceChecked === "mixed")
  );

  // If no items are checked, check all items for this supplier before opening the modal
  if (!hasCheckedItems) {
    checkAllSupplierItems(supplier, type, (supplier.invoiceChecked = true), supplier.id, "all");
  } else {
    // If items are already checked, just map the checked resources for the notification
    mapResourcesToNotification(type, supplier.id);
  }

  openSendNotificationsModal();
};

const hasCustomNotes = (supplier: any) => {
  // Check supplier-level notes first
  const notes = supplier?.notes ?? supplier?.note;
  if (notes !== null && notes !== undefined) {
    const textContent = String(notes)
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim();
    if (textContent !== '') return true;
  }
  // Fallback: check resource-level notes
  const resources = supplier?.itemResourcesGrouped || [];
  for (const group of resources) {
    for (const resource of group?.resources || []) {
      const resNotes = resource?.notes ?? resource?.note;
      if (resNotes !== null && resNotes !== undefined) {
        const textContent = String(resNotes)
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/g, ' ')
          .trim();
        if (textContent !== '') return true;
      }
    }
  }
  return false;
};

const openCustomNotesModal = (supplier: any) => {
  supplierIdForCustomNote.value = supplier;
  openOffCanvas("the-custom-notes-off-canvas");
};

const toggleActionMenu = (id: string | number) => {
  if (id === 0 || showPax.value) return;
  hoveredId.value = id;
};

const closeActionMenu = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  if (!target.closest(".icon-container") && !target.closest(".cursor-pointer")) {
    hoveredId.value = 0;
    showPax.value = false;
  }
};

onMounted(() => {
  window.addEventListener("click", closeActionMenu);
});

onUnmounted(() => {
  window.removeEventListener("click", closeActionMenu);
});

const checkAllResources = (type: any) => {
  _.forEach(pricing.value.items, (priceType) => {
    if (priceType.name === type.name) {
      _.forEach(priceType.suppliers, (supplier) => {
        supplier.invoiceChecked = true;

        _.forEach(supplier.itemResourcesGrouped, (item) => {
          item.invoiceChecked = true;
          _.forEach(item.resources, (resource) => {
            resource.invoiceChecked = true;
          });
        });
      });
    }
  });
};

const deselectAllResources = (type: any) => {
  _.forEach(pricing.value.items, (priceType) => {
    if (priceType.name === type.name) {
      _.forEach(priceType.suppliers, (supplier) => {
        supplier.invoiceChecked = false;

        _.forEach(supplier.itemResourcesGrouped, (item) => {
          item.invoiceChecked = false;
          _.forEach(item.resources, (resource) => {
            resource.invoiceChecked = false;
          });
        });
      });
    }
  });
};

const setCurrentItem = (item: any) => {
  const payload = {
    agency: agency.value.slug,
    caseId: Number(caseId),
    caseDayId: item?.caseDayId,
    caseDayItemId: item?.caseDayItemId,
  };
  openItemDetailsOffCanvas(payload);
};

const openItemDetailsOffCanvas = async (data: any) => {
  statusTourDayItem.value = "loading";

  if (offCanvasToShow.value !== "the-tour-day-item-details-off-canvas") {
    openOffCanvas("the-tour-day-item-details-off-canvas");
  }

  await userStore.setCurrentCaseDayItem(data);

  statusTourDayItem.value = "loaded";
};

const deleteItem = async (itemResource: any) => {
  await $modal?.delete({
    title: t("tourBuilder.deleteTourDayItemTitle"),
    text: t("tourBuilder.deleteTourDayItemText", {
      dayItem: itemResource?.name,
    }),
    deleteButtonText: t("general.button.delete"),
    rightButtonClasses: "btn-tertiary",
    deleteButtonCallback: () => doDeleteItem(itemResource),
  });
};

const doDeleteItem = async (itemResource: any) => {
  status.value = "loading";

  const loadingToast = $toast?.loading(t("general.button.deleting"), "toast-remove-tour-day-item");

  try {
    await api.case.caseDeleteBulkResources(agency.value.slug, Number(caseId), {
      resourceIds: itemResource?.tourDayItemResourceIds,
    });

    loadTourPricing();

    status.value = "loaded";

    loadingToast?.update("toast-remove-tour-day-item", {
      content: t("tourBuilder.dayItemDeleted"),
      options: {
        type: TYPE.SUCCESS,
        icon: "icon icon-check-circle-fill",
        timeout: 5000,
      },
    });
  } catch (e: any) {
    loadingToast?.update("toast-remove-tour-day-item", {
      content: t("tourBuilder.dayItemDeleteError"),
      options: {
        type: TYPE.ERROR,
        icon: "icon icon-exclamation-triangle-fill",
        timeout: 5000,
      },
    });

    console.error(e?.response?.data);
    toast.error(e?.response?.data?.message || e);
  }
};

const clearCurrentTourDayItem = () => {
  userStore.setCurrentTourDayItem(null);
};

const checkItemsInvoiceChecked = (items: any[]): boolean | "mixed" => {
  const isAllCheckTrue = items.every((group: any) => group.invoiceChecked === true);

  if (isAllCheckTrue) {
    return true;
  } else {
    const isAllCheckFalse = items.every((group: any) => group.invoiceChecked === false);
    return isAllCheckFalse ? false : "mixed";
  }
};

const checkSupplier = (supplier: any) => {
  supplier.invoiceChecked = checkItemsInvoiceChecked(supplier.itemResourcesGrouped);
};

const checkSupplierResource = (itemResourcesGrouped: any, supplier: any) => {
  itemResourcesGrouped.invoiceChecked = checkItemsInvoiceChecked(itemResourcesGrouped.resources);
  checkSupplier(supplier);
};

const checkSupplierResourceGroup = (supplier: any, itemResource: any) => {
  itemResource.resources.forEach((resource: any) => {
    resource.invoiceChecked = itemResource.invoiceChecked;
  });

  checkSupplier(supplier);
};
const loadTourPricing = async (showLoaderFlag = false, pricingData: any[] = []) => {
  const totalStart = performance.now();
  if (showLoaderFlag) showLoader.value = true;
  if (!agency.value) return;

  logClient('loadTourPricing: start', 'info', { showLoaderFlag, hasPricingData: !!(pricingData && pricingData.length > 0) });

  let response;

  if (!pricingData || pricingData.length === 0) {
    const apiStart = performance.now();
    logClient('loadTourPricing: fetching pricing data', 'info');
    const data = await api.case.casePricingDetails(agency.value.slug, Number(caseId));
    const apiElapsed = Math.round(performance.now() - apiStart);
    logClient('loadTourPricing: pricing data received', 'info', {
      elapsed_ms: apiElapsed,
      day_item_count: data?.content?.old?.length ?? 0,
    });
    lock.value = data?.content?.is_quote_price_locked;
    quotePrice.value = data?.content?.quote_price;
    initialQuotePrice.value = data?.content?.quote_price;
    response = data.content.old;
  } else {
    logClient('loadTourPricing: using provided pricing data', 'info', { day_item_count: pricingData.length });
    response = pricingData;
  }
  const gropDAta = response;


  // Step 1: Sort data (stable: by start_date, then by id to preserve order after price updates)
  const sortedData = _.sortBy(gropDAta, [(item) => item.start_date, (item) => item.id]);

  // Step 2: Group by type
  const groupedByType = _.groupBy(sortedData, (item) => item.type || "unknown");

  // Step 3: Sort types (accommodations first: hotel, then refuge, then others)
  const typeOrder: Record<string, number> = { hotel: 0, refuge: 1 };
  const getTypeOrder = (t: string) => (t in typeOrder ? typeOrder[t] : 2);
  const sortedTypes = Object.keys(groupedByType).sort((a, b) => {
    const orderDiff = getTypeOrder(a) - getTypeOrder(b);
    if (orderDiff !== 0) return orderDiff;
    return a.localeCompare(b);
  });

  const pricingItems = sortedTypes
    .map((name) => {
      const caseDayItems = _.sortBy(groupedByType[name], [(item) => item.start_date, (item) => item.id]);
      const { netPrice, grossPrice, markup } = calculatePrice(caseDayItems);

      // ---- Supplier Grouping ----
      const supplierGroups: { [key: string]: TourDayItemResource[] } = {};
      for (const item of caseDayItems) {
        if (!item.item_data) continue;
        const supplier = item.item_data;

        // Hotels: group by supplier + day (each day is a separate row)
        // Transport/luggage: group by supplier only (all days under one row)
        // Other types: group by supplier only (all days under one row)
        const key = isAccommodationType(supplier.type)
          ? `${supplier.id}-${item.case_day_id}`
          : `${supplier.id}`;
        (supplierGroups[key] ||= []).push(item);
      }

      const suppliersMapped = Object.values(supplierGroups)
        .map((groupItems) => {
          const firstItem = groupItems[0];
          const supplier = firstItem.item_data;

          // skip if NO resources at all across the group
          const anyResources = groupItems.some(
            (it) => Array.isArray(it.case_day_item_resources) && it.case_day_item_resources.length > 0
          );
          if (!anyResources) return null;

          const makeGroupKey = (parentItem: any, resource: any) => {
            const resPayment = resource?.payment_status ?? parentItem?.payment_status ?? "";
            const resBooking = resource?.booking_status ?? parentItem?.booking_status ?? "";
            const resInvoice = resource?.invoice_status ?? parentItem?.invoice_status ?? "";
            const itemType = parentItem.type ?? parentItem.item_data?.type ?? "";
            const supplierResId = resource?.supplier_resource?.id ?? resource?.supplier_resource_id ?? "";

            if (isAccommodationType(itemType)) {
              // Hotels: group only when room type, checkin, checkout, net_price, and statuses all match
              const resStart = resource?.checkin_date ?? parentItem?.checkin_date ?? "";
              const checkin = resource?.checkin_date ?? parentItem?.checkin_date;
              const nights = resource?.nights ?? parentItem?.nights ?? 0;
              const resEnd = (checkin && nights)
                ? DateTime.fromISO(checkin).plus({ days: nights }).toISODate()
                : "";
              const resNet = roundPrice(resource?.net_price ?? parentItem?.net_price ?? 0);
              return `${supplierResId}-${resStart}-${resEnd}-${resNet}-${resPayment}-${resBooking}-${resInvoice}`;
            }

            if (itemType === "transfer" || itemType === "transport" || itemType === "luggage_transport") {
              // Transfers/transport/luggage: group by same supplier + same statuses (across all dates and resources)
              const supplierId = parentItem?.item_data?.id ?? parentItem?.model_id ?? "";
              return `${supplierId}-${resPayment}-${resBooking}-${resInvoice}`;
            }

            // Other services: group by same resource + same checkin date + same statuses
            const resStart = resource?.checkin_date ?? parentItem?.checkin_date ?? "";
            return `${supplierResId}-${resStart}-${resPayment}-${resBooking}-${resInvoice}`;
          };

          const groupMap: Record<string, any[]> = {};

          for (const parentItem of groupItems) {
            const resources = parentItem.case_day_item_resources ?? [];
            for (const res of resources) {
              const key = makeGroupKey(parentItem, res);
              (groupMap[key] ||= []).push({ parentItem, resource: res });
            }
          }

          const itemResourcesGrouped = Object.values(groupMap).map((bucket) => {
            const dates = bucket
              .map((b: any) => b.resource?.checkin_date ?? b.parentItem?.checkin_date)
              .filter(Boolean);
            const date = dates.length ? dates.sort()[0] : null;
            const endDates = bucket
              .map((b: any) => {
                const checkout = b.resource?.checkout_date ?? b.parentItem?.checkout_date;
                if (checkout) return checkout;
                const checkin = b.resource?.checkin_date ?? b.parentItem?.checkin_date;
                const nights = b.resource?.nights ?? b.parentItem?.nights ?? 0;
                if (checkin && nights) {
                  return DateTime.fromISO(checkin).plus({ days: nights }).toISODate();
                }
                return null;
              })
              .filter(Boolean);
            const endDate = endDates.length ? endDates.sort()[0] : null;

            const mappedResources = _.sortBy(
              bucket.map(({ parentItem, resource }: any) => ({
                id: resource.id,
                netPrice: roundPrice(resource.net_price),
                grossPrice: roundPrice(resource.gross_price ?? resource.grossPrice ?? 0),
                markup: roundPrice(resource.markup ?? 0),
                dbPrice: roundPrice(resource.db_price),
                supplierPrice: roundPrice(resource.supplier_price),
                amountPaid: roundPrice(resource.amount_paid ?? resource.amountPaid ?? 0),
                amountPending: roundPrice(resource.amount_pending ?? resource.amountPending ?? 0),
                markToPay: !!resource.mark_to_pay,
                splitPayment: !!resource.split_payment,
                paymentComplete: !!resource.payment_complete,
                paymentPartial: !!resource.payment_partial,
                paymentPending: !!resource.payment_pending,
                accepted: !!resource.accepted,
                tourDayId: resource.tour_day_id ?? parentItem.tour_day_id ?? null,
                tourDayItemId: parentItem.id ?? null,
                caseDayId: parentItem.case_day_id ?? null,
                isUpdatedBySupplier: !!resource.is_updated_by_supplier,
                isPriceValidated: !!resource.is_price_validated,
                isConnectedToHolded: !!resource.is_connected_to_holded,
                netValidated: !!(resource.is_price_validated ?? parentItem.is_price_validated),
                reservationStatus: resource.booking_status ?? parentItem.booking_status,
                invoiceStatus: resource.invoice_status ?? parentItem.invoice_status,
                paymentStatus: resource.payment_status ?? parentItem.payment_status,
                notes: resource.notes ?? parentItem.notes ?? null,
                initHour: resource.init_hour ?? null,
                endHour: resource.end_hour ?? null,
                originName: (resource.is_connected_by_system
                  ? (resource.origin_supplier?.name ?? null)
                  : (resource.origin_location?.name ?? null))
                  ?? parentItem.case_day?.origin?.name
                  ?? null,
                originUrl: (resource.is_connected_by_system
                  ? (resource.origin_supplier?.lat && resource.origin_supplier?.lng
                    ? `https://www.google.com/maps?q=${resource.origin_supplier.lat},${resource.origin_supplier.lng}`
                    : null)
                  : (resource.origin_location?.lat && resource.origin_location?.lng
                    ? `https://www.google.com/maps?q=${resource.origin_location.lat},${resource.origin_location.lng}`
                    : null))
                  ?? (parentItem.case_day?.origin?.lat && parentItem.case_day?.origin?.lng
                    ? `https://www.google.com/maps?q=${parentItem.case_day.origin.lat},${parentItem.case_day.origin.lng}`
                    : null),
                destinationName: (resource.is_connected_by_system
                  ? (resource.destination_supplier?.name ?? null)
                  : (resource.destination_location?.name ?? null))
                  ?? parentItem.case_day?.destination?.name
                  ?? ((parentItem.type === 'transfer' || parentItem.type === 'transport' || parentItem.type === 'luggage_transport')
                    ? (parentItem.case_day?.origin?.name ?? null)
                    : null)
                  ?? null,
                destinationUrl: (resource.is_connected_by_system
                  ? (resource.destination_supplier?.lat && resource.destination_supplier?.lng
                    ? `https://www.google.com/maps?q=${resource.destination_supplier.lat},${resource.destination_supplier.lng}`
                    : null)
                  : (resource.destination_location?.lat && resource.destination_location?.lng
                    ? `https://www.google.com/maps?q=${resource.destination_location.lat},${resource.destination_location.lng}`
                    : null))
                  ?? (parentItem.case_day?.destination?.lat && parentItem.case_day?.destination?.lng
                    ? `https://www.google.com/maps?q=${parentItem.case_day.destination.lat},${parentItem.case_day.destination.lng}`
                    : ((parentItem.type === 'transfer' || parentItem.type === 'transport' || parentItem.type === 'luggage_transport')
                      ? (parentItem.case_day?.origin?.lat && parentItem.case_day?.origin?.lng
                        ? `https://www.google.com/maps?q=${parentItem.case_day.origin.lat},${parentItem.case_day.origin.lng}`
                        : null)
                      : null)),
                supplierResource: resource.supplier_resource ?? {
                  id: resource.supplier_resource_id ?? null,
                  name: resource.supplier_resource?.name ?? parentItem.item_data?.name ?? null,
                  type: resource.supplier_resource?.type ?? parentItem.item_data?.type ?? null,
                  resource_type: resource.supplier_resource?.resource_type ?? null,
                },
                supplierResourceName: resource.supplier_resource?.name ?? parentItem.item_data?.name ?? null,
                date: resource.checkin_date ?? parentItem.checkin_date ?? null,
                endDate: resource.checkout_date
                  ?? parentItem.checkout_date
                  ?? (resource.checkin_date && resource.nights
                    ? DateTime.fromISO(resource.checkin_date).plus({ days: resource.nights }).toISODate()
                    : (parentItem.checkin_date && parentItem.nights
                      ? DateTime.fromISO(parentItem.checkin_date).plus({ days: parentItem.nights }).toISODate()
                      : null)),
                paxes:
                  (resource?.paxes || [])
                    ?.map((p: any) => p.pax?.name || p.name)
                    ?.sort((a: string, b: string) => a.localeCompare(b)) || [],
              })),
              [(r) => r.date ?? "", (r) => r.id]
            );

            const totalNetPrice = roundPrice(_.sumBy(mappedResources, "netPrice"));

            return {
              date,
              endDate,
              resources: mappedResources,
              dbPrice: mappedResources[0]?.dbPrice ?? 0,
              paxes: _.uniq(mappedResources.flatMap((r: any) => r.paxes || [])) as string[],
              supplierResourceId: mappedResources[0]?.supplierResource?.id ?? null,
              name: mappedResources[0]?.supplierResource?.name ?? supplier.name,
              type: mappedResources[0]?.supplierResource?.type ?? supplier.type,
              quantity: bucket.length,
              initHour: mappedResources[0]?.initHour ?? null,
              endHour: mappedResources[0]?.endHour ?? null,
              originName: mappedResources[0]?.originName ?? null,
              originUrl: mappedResources[0]?.originUrl ?? null,
              destinationName: mappedResources[0]?.destinationName ?? null,
              destinationUrl: mappedResources[0]?.destinationUrl ?? null,
              totalNetPrice,
              netPrice: totalNetPrice,
              grossPrice: roundPrice(_.sumBy(mappedResources, (r: any) => Number(r.grossPrice) || 0)),
              markup: mappedResources[0]?.markup ?? 0,
              amountPaid: roundPrice(_.sumBy(mappedResources, (r: any) => Number(r.amountPaid) || 0)),
              amountPending: roundPrice(_.sumBy(mappedResources, (r: any) => Number(r.amountPending) || 0)),
              markToPay: mappedResources.some((r: any) => r.markToPay),
              splitPayment: mappedResources.some((r: any) => r.splitPayment),
              paymentComplete: mappedResources.every((r: any) => r.paymentComplete),
              paymentPartial: mappedResources.some((r: any) => r.paymentPartial) && !mappedResources.every((r: any) => r.paymentComplete),
              paymentPending: mappedResources.every((r: any) => r.paymentPending),
              accepted: mappedResources.every((r: any) => r.accepted),
              tourDayId: mappedResources[0]?.tourDayId ?? null,
              tourDayItemId: mappedResources[0]?.tourDayItemId ?? null,
              paymentStatus: mappedResources[0]?.paymentStatus ?? null,
              reservationStatus: mappedResources[0]?.reservationStatus ?? null,
              invoiceStatus: mappedResources[0]?.invoiceStatus ?? null,
              netValidated: mappedResources[0]?.netValidated ?? false,
              supplierPrice: mappedResources[0]?.supplierPrice ?? 0,
              isUpdatedBySupplier: mappedResources[0]?.isUpdatedBySupplier ?? false,
              isPriceValidated: mappedResources[0]?.isPriceValidated ?? false,
              isConnectedToHolded: mappedResources.some((r: any) => r.isConnectedToHolded),
              tourDayItemResourceIds: bucket.map((b: any) => b.resource.id),
              caseDayId: bucket[0].parentItem.case_day_id,
              caseDayItemId: bucket[0].parentItem.id,
            };
          });

          return {
            ...supplier,
            invoiceChecked: false,
            itemResourcesGrouped: _.sortBy(itemResourcesGrouped, [(r) => r.date ?? "", (r) => r.supplierResourceId ?? 0, (r) => r.caseDayItemId ?? 0]),
            totalNetPrice: roundPrice(_.sumBy(itemResourcesGrouped, "totalNetPrice")),
            isConnectedToHolded: itemResourcesGrouped.some((g: any) => g.isConnectedToHolded),
            netValidated: itemResourcesGrouped[0]?.netValidated,
            paymentStatus: itemResourcesGrouped[0]?.paymentStatus,
            invoicePaymentStatus: itemResourcesGrouped.every((r) => r.paymentStatus === "complete")
              ? "complete"
              : "pending",
            reservationStatus: itemResourcesGrouped[0]?.reservationStatus,
            invoiceStatus: itemResourcesGrouped[0]?.invoiceStatus,
            type: supplier.type,
            name: supplier.name,
            caseDayId: firstItem.case_day_id,
            caseDayItemId: groupItems.find((it: any) => it.notes || it.note)?.id ?? firstItem.id,
            note: groupItems.find((it: any) => it.notes || it.note)?.notes ?? groupItems.find((it: any) => it.notes || it.note)?.note ?? null,
            notes: groupItems.find((it: any) => it.notes || it.note)?.notes ?? groupItems.find((it: any) => it.notes || it.note)?.note ?? null,
            paxes: firstItem.paxes,
            supplierPrice: itemResourcesGrouped[0]?.supplierPrice ?? 0,
            dbPrice: itemResourcesGrouped[0]?.dbPrice ?? 0,
            booking_type: firstItem.booking_type ?? supplier.booking_type ?? null,
            booking_type_meta: firstItem.booking_type_meta ?? supplier.booking_type_meta ?? null,
          };
        })
        .filter(Boolean);

      // Sort suppliers by earliest date, then by stable IDs (not name, which can change)
      const sortedSuppliers = _.orderBy(
        suppliersMapped,
        [
          (s) => s.itemResourcesGrouped?.[0]?.date || "9999-12-31",
          (s) => s.caseDayId ?? 0,
          (s) => s.caseDayItemId ?? 0,
        ],
        ["asc", "asc", "asc"]
      );

      // Only include this pricing item if there are valid suppliers
      if (sortedSuppliers.length === 0) return null;

      return {
        name,
        suppliers: sortedSuppliers,
        total: {
          grossPrice,
          markup,
          netPrice,
        },
      };
    })
    .filter(Boolean); // ✅ remove pricing items with no suppliers

  // Step 4: Assign to reactive state
  if (currentTour.value) {
    statusTotalPricing.value = "loading";
    const memoryBefore = getClientMemory();
    pricing.value = {
      items: markRaw(pricingItems),
      total: {
        netPrice: Number(currentTour.value.net_price),
        grossPrice: Number(currentTour.value.gross_price),
        markup: Number(currentTour.value.markup),
      },
    };
    statusTotalPricing.value = "loaded";
    logClient('loadTourPricing: pricing state assigned', 'info', {
      memory_before: memoryBefore,
      memory_after: getClientMemory(),
    });
  }

  const totalSupplierCount = pricingItems.reduce((acc: number, type: any) => acc + (type.suppliers?.length ?? 0), 0);
  const totalGroupCount = pricingItems.reduce((acc: number, type: any) =>
    acc + (type.suppliers?.reduce((sAcc: number, s: any) => sAcc + (s.itemResourcesGrouped?.length ?? 0), 0) ?? 0), 0);

  logClient('loadTourPricing: end', 'info', {
    elapsed_ms: Math.round(performance.now() - totalStart),
    type_count: pricingItems.length,
    supplier_count: totalSupplierCount,
    group_count: totalGroupCount,
  });

  // Don't wait for the debug log POST; the page must become responsive
  // even if the client-log endpoint is slow or unreachable.
  flushClientLogs();

  if (showLoaderFlag) showLoader.value = false;
  updateTourPricingChnage(false);
};

const getAssociatedIcon = (type: string) => {
  const defaultIcon = "compass";

  if (type) {
    return itemTypes.value.find((item: any) => item.key === type)?.icon || defaultIcon;
  }

  return defaultIcon;
};

// const sortTourDayItemResources = (items: TourDayItemResource[]): TourDayItemResource[] => {
//   return items.sort((a, b) => {
//     const dateA = new Date(a.date);
//     const dateB = new Date(b.date);
//     const dateEndA = new Date(a.endDate);
//     const dateEndB = new Date(b.endDate);

//     if (dateA.getTime() === dateB.getTime()) {
//       if (dateEndA.getTime() === dateEndB.getTime()) {
//         return a.id - b.id;
//       }

//       return dateEndA.getTime() - dateEndB.getTime();
//     }

//     return dateA.getTime() - dateB.getTime();
//   });
// };

const openCreateBillingInvoiceOffCanvas = () => {
  openOffCanvas("the-pricing-invoice-create-off-canvas");
};

// const openCreateInvoiceOffCanvas = () => {
//   totalInvoice.value = 0;
//   items.value.types = [];
//   items.value.resourceIds = [];

//   const allResources: IPricingItemSupplierResource[] = [];

//   _.forEach(pricing.value.items, (supplierType: IPricingItems) => {
//     _.forEach(supplierType.suppliers, (supplier: IPricingItemSupplier) => {
//       const supplierData = {
//         id: supplier.id,
//         name: supplier.name,
//       };

//       _.forEach(supplier.itemResourcesGrouped, (itemResource: IPricingItemSupplierResourceGrouped) => {
//         _.forEach(itemResource.resources, (resource: IPricingItemSupplierResource) => {
//           const resourceData = {
//             id: resource.supplierResourceId,
//             name: resource.name,
//           };

//           if (resource.invoiceChecked) {
//             allResources.push(resource);
//             items.value.resourceIds.push(resource.id);

//             const typeFounded = _.find(items.value.types, { name: supplierType.name });

//             if (!typeFounded) {
//               items.value.types.push({
//                 name: supplierType.name,
//                 suppliers: [
//                   {
//                     ...supplierData,
//                     itemResources: [
//                       {
//                         ...resourceData,
//                         resources: [resource.id],
//                       },
//                     ],
//                   },
//                 ],
//               });
//             } else {
//               const supplierFounded = _.find(typeFounded.suppliers, { id: supplier.id });

//               if (!supplierFounded) {
//                 typeFounded.suppliers.push({
//                   ...supplierData,
//                   itemResources: [
//                     {
//                       ...resourceData,
//                       resources: [resource.id],
//                     },
//                   ],
//                 });
//               } else {
//                 const itemResourceFounded = _.find(supplierFounded.itemResources, {
//                   id: resource.supplierResourceId,
//                 });

//                 if (!itemResourceFounded) {
//                   supplierFounded.itemResources.push({
//                     ...resourceData,
//                     resources: [resource.id],
//                   });
//                 } else {
//                   itemResourceFounded.resources.push(resource.id);
//                 }
//               }
//             }
//           }
//         });
//       });
//     });
//   });

//   let total = _.reduce(
//     allResources,
//     (sum, item) => sum + (_.toNumber(item.grossPrice) || 0),
//     0
//   );

//   if (total % 1 !== 0) {
//     total = Number(total.toFixed(2));
//   }

//   totalInvoice.value = total;

//   if (_.isEmpty(allResources)) {
//     toast.error(t("tourPricing.invoice.noResourcesSelectedMessage"));
//   } else {
//     openOffCanvas("the-pricing-invoice-create-off-canvas");
//   }
// };

// const totalNetPriceTour = (data: IPricingItemSupplierResourceGrouped[]): number => {
//   return _.reduce(data, (total, item) => total + item.netPrice, 0);
// };

const totalAmountPaid = (hotelName: string): number => {
  return summaryDataMap.value.get(hotelName)?.paidAmount ?? 0;
};

const totalPendingPriceDayTour = (hotelName: string): number => {
  return summaryDataMap.value.get(hotelName)?.pendingAmount ?? 0;
};

const totalPayablePriceDayTour = (hotelName: string): number => {
  return summaryDataMap.value.get(hotelName)?.payableAmount ?? 0;
};

// function openModal() {
//   showmodal.value = true;
// }

const closeModal = () => {
  showmodal.value = false;
};

const onConfirm = async () => {
  btnLoading.value = true;
  if (currentAction.value === "updateSold") {
    await updateSold();
  } else if (currentAction.value === "updateCancel") {
    await updateCancel();
  }
  closeConfirmModal();
};

const closeConfirmModal = () => {
  showConfirmationModal.value = false;
};

const emit = defineEmits(["sold-tour", "cancel-tour", "reload-client-tour"]);

const soldTour = async () => {
  await $modal?.confirm({
    title: t("tourBooking.sold"),
    text: t("general.shared.confirmationText", { title: t("tourBooking.sold") }),
    leftButtonClasses: "btn-tertiary",
    confirmButtonText: t("general.button.save"),
    confirmButtonCallback: updateSold,
  });
};

const cancelTour = async () => {
  await $modal?.confirm({
    title: t("tourBooking.cancel"),
    text: t("general.shared.confirmationText", { title: t("tourBooking.cancel") }),
    leftButtonClasses: "btn-tertiary",
    confirmButtonText: t("general.button.save"),
    confirmButtonCallback: updateCancel,
  });
};

const updateSold = async () => {
  try {
    const response = await api.case.caseSold(agency.value.slug, Number(caseId));
    if (response) {
      btnLoading.value = false;
      useToast().success(t("general.shared.savedChanges"));
      loadTourPricing();
      emit("reload-client-tour");
    }
  } catch (e) {
    console.error(e);
  }
};

const updateCancel = async () => {
  try {
    const response = await api.case.caseCancel(agency.value.slug, Number(caseId));
    if (response) {
      btnLoading.value = false;
      toast.success(t("general.shared.savedChanges"));
      loadTourPricing();
      emit("reload-client-tour");
    }
  } catch (e) {
    console.error(e);
  }
};

const updateQuotePrice = async (type: string) => {
  try {
    if (type === "input" && quotePrice.value === initialQuotePrice.value) return;

    const data = {
      is_quote_price_locked: lock.value,
      quote_price: quotePrice.value,
    };
    const response = await api.case.updateCaseQuotePrice(agency.value.slug, Number(caseId), data);
    if (response) {
      toast.success(t("general.shared.savedChanges"));
      getTourData();
    }
  } catch (e) {
    console.error(e);
  }
};

const getTourData = async () => {
  try {
    await userStore.setCurrentCase(agency.value.slug, Number(caseId));

    const data = currentTour.value;
    lock.value = data?.is_quote_price_locked;
    quotePrice.value = data?.quote_price;
    initialQuotePrice.value = data?.quote_price;
  } catch (e) {
    console.error(e);
  }
};

const inVoiceSummaryModal = () => {
  inVoiceSummary.value = true;
};

const closeInvoiceSummaryModal = () => {
  inVoiceSummary.value = false;
};

const getSupplierTypeTotal = (suppliers: any[]): number => {
  const totalCents = suppliers.reduce((sum: number, supplier: any) => {
    const price = Number(supplier?.totalNetPrice || 0);
    return sum + Math.round(price * 100);
  }, 0);

  return totalCents / 100;
};

const doResetHoldedConnection = async (supplier: any) => {
  const resourceIds = supplier.itemResourcesGrouped?.flatMap((g: any) => g.tourDayItemResourceIds || []) || [];
  if (!resourceIds.length) return;

  try {
    await api.case.caseResetHoldedConnection(agency.value.slug, Number(caseId), { resourceIds });

    supplier.isConnectedToHolded = false;
    supplier.itemResourcesGrouped?.forEach((g: any) => {
      g.isConnectedToHolded = false;
      g.resources?.forEach((r: any) => {
        r.isConnectedToHolded = false;
      });
    });

    toast.success("Holded connection reset");
  } catch (e: any) {
    toast.error(e?.response?.data?.message || "Failed to reset Holded connection");
  }
};

const resetHoldedConnection = async (supplier: any) => {
  await $modal?.confirm({
    title: "Reset Holded connection",
    text: `This will reset the Holded connection for ${supplier.name} and allow the resources to be re-integrated.`,
    leftButtonClasses: "btn-tertiary",
    confirmButtonText: t("general.button.confirm"),
    confirmButtonCallback: () => doResetHoldedConnection(supplier),
  });
};

onMounted(() => {
  const priceStore = usePriceStore();
  priceStore.clearPriceData();
});

onUnmounted(() => {
  userStore.setCurrentCaseDayItem(null);
});

defineExpose({ soldTour, cancelTour, inVoiceSummaryModal });
</script>

<style lang="scss" scoped>
.preview-container {
  margin-right: 1rem;
  margin-top: 0.5rem;
}

.pricing-type-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 6px;
  background-color: #fd0c6f;
}

.supplier-initial-badge {
  font-size: 0.75rem;
  width: 24px;
  height: 24px;
  background-color: #fd0c6f;
  color: #fff;
}

.accordion-toggle {
  cursor: pointer;
}

.status-title {
  height: 49px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
}

.suppliers-header {
  .th {
    padding-left: 2.75rem !important;
  }
}

.suppliers-header,
.resources-profit-header {
  border-top: 1px solid #e2e8f0;
  .th {
    padding: 0.5rem 0.375rem;
    font-weight: 500;
    font-size: 0.75rem;

    @media (min-width: 1400px) {
      font-size: 0.8rem;
    }
  }
}

.suppliers-body {
  .supplier-container {
    border: 1px solid var(--uq-gray-400);
    border-radius: 0.25rem;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  .supplier-data {
    position: relative;

    .td {
      padding-inline: 0.375rem;
      font-weight: 300;
    }
  }

  .supplier-name {
    font-size: 0.75rem;

    @media (min-width: 992px) {
      font-size: 0.8rem;
    }

    @media (min-width: 1200px) {
      font-size: 0.8rem;
    }
  }

  .row {
    padding: 0.375rem;
    font-size: 0.8rem;

    @media (min-width: 992px) {
      font-size: 0.8rem;
    }

    .td {
      padding-inline: 0.375rem;
      font-weight: 300;
    }
  }
}

.item-list {
  .resources-container {
    position: relative;
    margin-bottom: 1rem;
    padding-bottom: 0;
  }

  .type-total,
  .pricing-total {
    padding-block: 0.5rem;
    border: 1px solid var(--uq-gray-400);
    border-radius: 0.25rem;
  }
}

.spinner-border {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 1050;
}

.suppliers-body {
  .tour-day-item-resource-container,
  .wrapper {
    position: relative;
    padding-top: 0.75rem;

    &:not(:last-child) {
      padding-bottom: 0.75rem;
    }

    &:not(:last-child):after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: var(--uq-gray-300);
    }

    &.bg-gray-200 {
      :deep(.form-outline .label span) {
        background-color: #f7f7fc !important;
      }

      :deep(.input-group .input-group-text) {
        background-color: #f0f0f9;
      }
    }

    :deep(.input-group .input-group-text) {
      background-color: #f7f7fc;
    }
  }

  .mobile-view {
    display: none;
  }

  .sub-container {
    width: 44%;

    :deep(.form-control) {
      padding-inline: 1rem;
      min-height: 32px !important;
      height: 32px !important;
    }

    :deep(.input-group-text) {
      height: 32px;
    }
  }

  .form-check-inline {
    margin-top: 8px;
  }

  @media (max-width: 993px) {
    .normal-view {
      display: none;
    }

    .mobile-view {
      display: flex;
    }

    .sub-container {
      width: 100%;
      margin-left: 1rem;
      margin-top: 1rem;
    }
  }
}

.dashed:not(:last-child) {
  padding-bottom: 1rem;
  border-bottom: 1px dashed var(--uq-gray-400);
}

.accordion-toggle {
  .accordion-icon {
    right: 0.5rem;
  }
}

.icon-container {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 100%;
  left: 0;
  transform: translateY(-10px);
  background: white;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  z-index: 1050;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 8px;
  pointer-events: none;
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  &.show-actions {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 12px;
    transform: rotate(45deg);
    width: 12px;
    height: 12px;
    background: white;
    border-right: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
  }
}


.icon-layout {
  margin-left: -3.5rem;
}

.send-notification {
  position: absolute;
  top: 0.4rem;
  right: 3rem;
}

.supplier-info {
  display: flex;
  justify-content: end;
  margin: 0 auto;
  width: 100%;
  margin-top: -4px;
}

.lock-btn {
  margin-left: 0.5rem;
  align-content: center;
}

.hidden-conatiner {
  width: 2.5rem;
}

:deep(.notes-icon-wrapper--active .btn) {
  background-color: #57c68a !important;
  border-color: #57c68a !important;
  color: #fff !important;
}

:deep(.notes-icon-wrapper--active .btn:hover) {
  background-color: #45b478 !important;
  border-color: #45b478 !important;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  background-color: #bbe5f1;
  color: black;
  text-align: center;
  padding: 6px 12px;
  border-radius: 6px;
  position: absolute;
  z-index: 1000;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;

  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border-width: 6px;
  border-style: solid;
  border-color: #bbe5f1 transparent transparent transparent;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.resource-header {
  margin-bottom: 12px;
  padding: 6px 0;
}

.hotel-header {
  width: 75%;
  gap: 8px;
}

/* Providers circular button in accordion header */
.providers-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--uq-dark, #212529);
  border: none;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
}

/* Compact font sizes */
.text-xs { font-size: 0.75rem !important; }

.resources-profit-header .th,
.suppliers-header .th {
  font-size: 0.75rem !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 4px 6px;
}

.suppliers-body .row {
  font-size: 0.8rem;
}

.supplier-data .td {
  font-size: 0.8rem;
}

/* Fix net price / total inputs: ensure proper label float */
:deep(.form-outline .label span),
:deep(.form-outline label) {
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px;
}

:deep(.form-control) {
  font-size: 0.8rem;
  min-height: 32px;
  height: 32px;
  padding: 0 8px;
}

:deep(.input-group-text) {
  font-size: 0.8rem;
  height: 32px;
  padding: 0 8px;
}

.dropdown-menu {
  padding: 0.3rem 0 !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.pax-dropdown {
  min-width: 180px;
  border-radius: 10px;
}

.pax-dropdown .dropdown-item {
  cursor: default;
}

.pax-dropdown .dropdown-item:hover {
  background-color: #f5f7fa;
}

/* Always-visible border for pricing sections, with enhanced hover shadow */
.pricing-billing-section,
.pricing-type-section {
  border: 1px solid #e2e8f0;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
}

.pricing-badge {
  font-size: 0.75rem !important;
  font-weight: 500 !important;
}

:deep(.btn-icon:not(.rounded-circle)) {
  border-radius: 6px !important;
}

:deep(.btn:not(.rounded-circle)) {
  border-radius: 6px !important;
}

:deep(.btn-primary) {
  background-color: #fd0c6f !important;
  border-color: #fd0c6f !important;
  color: #fff !important;
}

:deep(.btn-primary:hover) {
  background-color: #dc095f !important;
  border-color: #dc095f !important;
}

:deep(.btn-success) {
  background-color: #57c68a !important;
  border-color: #57c68a !important;
  color: #fff !important;
}

:deep(.btn-success:hover) {
  background-color: #45b478 !important;
  border-color: #45b478 !important;
}

.pricing-badge.bg-primary {
  background-color: #fd0c6f !important;
  color: #fff !important;
}

.pricing-badge.bg-info {
  background-color: #f09d57 !important;
  color: #222422 !important;
}

.pricing-badge.bg-secondary {
  background-color: #222422 !important;
  color: #fff !important;
}

.pricing-badge.bg-warning {
  background-color: #e2c92e !important;
  color: #222422 !important;
}

.pricing-badge.bg-danger {
  background-color: #dc095f !important;
  color: #fff !important;
}
</style>
